import {
  Component,
  ElementRef,
  ViewChild,
  signal,
  inject,
  DestroyRef,
  OnInit,
  ChangeDetectionStrategy,
  AfterViewInit,
} from '@angular/core';
import { toSignal, takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { UntypedFormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent } from '@angular/material/dialog';
import { User } from 'src/app/models/user.model';
import { FormControl } from '@angular/forms';
import { ApiService } from 'src/app/services/api.service';
import { UserService } from 'src/app/services/user.service';
import { environment } from 'src/environments/environment';
import { CompanyProductPhaseBoardCol } from 'src/app/models/company_product_phase_board_col.model';
import { SecondsToStringTimePipe } from 'src/app/pipes/seconds-to-string-time.pipe';
import { WorkingTimeCategory } from 'src/app/models/working_time_category.model';
import { WorkingTime } from 'src/app/models/working_time.model';
import { MatAutocompleteSelectedEvent, MatOption, MatAutocompleteTrigger, MatAutocomplete } from '@angular/material/autocomplete';
import { MatChipInputEvent, MatChipGrid, MatChipRow, MatChipRemove, MatChipInput, MatChipsModule } from '@angular/material/chips';
import { Observable, Subject, firstValueFrom, of, shareReplay } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, filter, finalize, map, startWith, switchMap, tap } from 'rxjs/operators';
import { ProductTaskTagCategory } from 'src/app/models/product_task_tag_category.model';
import { AddNewWorkingTimeDialogComponent } from '../../../employees/activity/working-times-history/add-new-working-time-dialog/add-new-working-time-dialog.component';
import { PermissionsService } from 'src/app/services/permissions.service';
import { ProductTaskComment } from 'src/app/models/product_task_comment.model';
import { TinymceService } from 'src/app/services/tinymce.service';
import { CompanyProductPhaseBoard } from 'src/app/models/company_product_phase_board.model';
import { ProductTask, ProductTaskIssueOrigin } from 'src/app/models/product_task.model';
import { ProductTaskBoard } from 'src/app/models/product_task_board.model';
import { Attachment } from 'src/app/models/attachment.interface';
import { ProductTaskBoardTimeBudget } from 'src/app/models/product_task_board_time_budget.model';
import { CompanyProductTeam } from 'src/app/models/company_product_team.model';
import { ProductTaskTimeBudget } from 'src/app/models/product_task_time_budget.model';
import { CompanyProductUserMember } from 'src/app/models/company_product_user_member.model';
import { DecimalPipe, NgClass, NgTemplateOutlet, NgStyle, AsyncPipe, SlicePipe, DatePipe } from '@angular/common';
import { MatSelectChange, MatSelect, MatSelectTrigger } from '@angular/material/select';
import { InputDialogComponent } from '../../input-dialog/input-dialog.component';
import { TextDialogComponent } from '../../text-dialog/text-dialog.component';
import { WorkingContractVariableCondition } from 'src/app/models/working_contract_variable_condition.model';
import dayjs from 'dayjs';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { NgxDropzoneChangeEvent, NgxDropzoneModule } from 'ngx-dropzone';
import { MatFormField } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { EditorComponent } from '@tinymce/tinymce-angular';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { ProfilePicWithRoleComponent } from '../../../../utils/profile-pic-with-role/profile-pic-with-role.component';
import { CompanyProductGithubPullRequestLinkComponent } from 'src/app/components/main/shared/company-products/company-product-github-pull-request-link/company-product-github-pull-request-link.component';
import { SecondsToStringTimePipe as SecondsToStringTimePipe_1 } from '../../../../../pipes/seconds-to-string-time.pipe';
import { ProductTaskTypeImagePipe } from '../../../../../pipes/product-task-type-image.pipe';
import { DateAgoPipe } from '../../../../../pipes/date-ago.pipe';
import { StripHtmlPipePipe } from '../../../../../pipes/strip-html.pipe';
import { ProductTaskHistoryLogFieldPipePipe } from '../../../../../pipes/product-task-history-log-field.pipe';
import { ProductTaskPriorityFieldPipePipe } from '../../../../../pipes/product-task-priority-field.pipe';
import { ProductTaskTypeDescriptionPipe } from '../../../../../pipes/product-task-type-description.pipe';
import { ProductTaskTypeFieldPipePipe } from '../../../../../pipes/product-task-type-field.pipe';
import { ProductTaskDesignLinksCrudDialog } from './product-task-design-links-crud-dialog/product-task-design-links-crud-dialog.component';
import { TaskTimeBudgetDialogComponent, TaskTimeBudgetDialogData } from './task-time-budget-dialog/task-time-budget-dialog.component';
import { ProductTaskDesignLink } from 'src/app/models/product_task_design_link.model';
import { CreateProductTaskDialogComponent } from '../create-product-task-dialog/create-product-task-dialog.component';
import { ProductTaskHistoryLog } from 'src/app/models/product_task_history_log.model';
import { EmployeeService, UtilsService } from 'src/app/services';
import { BisualSettingService } from 'src/app/services/bisual-setting.service';
import { CompanyProductPhaseBoardDetailComponent } from '../company-product-detail/company-product-phases/company-product-phase-detail/company-product-phase-boards/company-product-phase-board-detail/company-product-phase-board-detail.component';
import { CompanyProductPhaseTaskTimeAutocalcSetting } from 'src/app/models/company_product_phase_task_time_autocalc_setting.model';
import { CompanyProductPhase } from 'src/app/models/company_product_phase.model';
import { ComponentCanDeactivate, PendingChangesGuard } from 'src/app/guards/pending-changes.guard';
import { CompanyProductEpic } from 'src/app/models/company_product_epic.model';
import { MatDividerModule } from '@angular/material/divider';
import { CompanyProductDeploy } from 'src/app/models/company_product_deploy.model';
import { ProductTaskOriginCategory } from 'src/app/models/product_task_origin_category.model';
import { ProductTaskOriginCategoryTypeAvailableEnum } from 'src/app/enums/product-task-origin-category-type-available.enum';
import { ArrayResponse } from 'src/app/models/array_response.interface';
import { ProductTaskTypeEnum } from 'src/app/enums/product-task-type.enum';
import {
  CompanyProductPhaseUserPermissions,
  EMPTY_COMPANY_PRODUCT_PHASE_USER_PERMISSIONS,
} from 'src/app/interfaces/company-product-phase-user-permissions.interface';
import { ProductTaskCommentOriginEnum } from 'src/app/enums/product-task-comment-origin.enum';
import { MediaPreviewKind } from 'src/app/enums/media-preview-kind.enum';
import { MediaPreviewDialogComponent } from './media-preview-dialog/media-preview-dialog.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AddUserDialogComponent } from 'src/app/components/main/employees/direction/users/add-user-dialog/add-user-dialog.component';
import { AddUserDialogData } from 'src/app/interfaces/add-user-dialog-data.interface';
import { ClientRoleEnum } from 'src/app/enums/client-role.enum';
import { RoleSlugEnum } from 'src/app/enums/role-slug.enum';
import { CompanyProduct } from 'src/app/models/company_product.model';

@Component({
  selector: 'app-product-task-detail',
  templateUrl: './product-task-detail.component.html',
  styleUrls: ['./product-task-detail.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatDialogTitle,
    MatIconButton,
    MatTooltip,
    MatIcon,
    CompanyProductGithubPullRequestLinkComponent,
    CdkScrollable,
    MatDialogContent,
    NgxDropzoneModule,
    MatFormField,
    MatInput,
    FormsModule,
    EditorComponent,
    NgClass,
    NgTemplateOutlet,
    MatProgressSpinner,
    MatButton,
    MatSelect,
    MatOption,
    MatSelectTrigger,
    MatCheckbox,
    MatMenuTrigger,
    NgStyle,
    MatMenu,
    MatMenuItem,
    ProfilePicWithRoleComponent,
    MatChipGrid,
    MatChipRow,
    MatChipRemove,
    MatChipInput,
    MatAutocompleteTrigger,
    ReactiveFormsModule,
    MatAutocomplete,
    AsyncPipe,
    SlicePipe,
    DecimalPipe,
    DatePipe,
    SecondsToStringTimePipe_1,
    ProductTaskTypeImagePipe,
    DateAgoPipe,
    StripHtmlPipePipe,
    ProductTaskHistoryLogFieldPipePipe,
    ProductTaskPriorityFieldPipePipe,
    ProductTaskTypeDescriptionPipe,
    ProductTaskTypeFieldPipePipe,
    MatChipsModule,
    MatDividerModule,
  ],
})
export class ProductTaskDetailComponent implements OnInit, AfterViewInit, ComponentCanDeactivate {
  private dialogRef = inject<MatDialogRef<ProductTaskDetailComponent>>(MatDialogRef);
  private userService = inject(UserService);
  private dialog = inject(MatDialog);
  data = inject<ProductTaskDetailDialogData>(MAT_DIALOG_DATA);
  private snack = inject(MatSnackBar);
  private api = inject(ApiService);
  private permissions = inject(PermissionsService);
  tinymce = inject(TinymceService);
  private secondsToStringTime = inject(SecondsToStringTimePipe);
  private decimal = inject(DecimalPipe);
  private employee = inject(EmployeeService);

  PRODUCT_TASK_BOARD_CHILDREN_PARAMS =
    'product_task_boards..product_task_board_time_budgets..budgetable,product_task_boards..product_task_board_time_budgets..assignee,product_task_boards..product_task_board_time_budgets..working_times..user,product_task_boards..product_task_board_time_budgets..working_times..relatable..budgetable,product_task_boards..product_task_board_time_budgets..history_logs..product_task_decline_reasons';

  task: ProductTaskCustom;
  product_task_board = signal<ProductTaskBoardCustom | undefined>(undefined);
  company_product_phase_id: number = this.data.company_product_phase_id;
  company_product_phase: CompanyProductPhase | undefined;
  company_product_id: number = this.data.company_product_id;
  activeActivityMenu: 'all' | 'comments' | 'history' | 'worklog' | 'distribution' | 'deploys' = 'comments';
  taskDeploys: CompanyProductDeploy[] = [];
  product_task_origin_categories: ProductTaskOriginCategory[] = [];
  filtered_origin_categories: ProductTaskOriginCategory[] = [];

  task_nav_move_abilities: TaskNavMoveAbilities = this.data.task_nav_move_abilities ?? {
    up: true,
    down: true,
    left: true,
    right: true,
  };
  task_nav_move_display: TaskNavMoveDisplay[] = [
    { move: TaskNavMove.Up, icon: 'arrow_upward' },
    { move: TaskNavMove.Down, icon: 'arrow_downward' },
    { move: TaskNavMove.Left, icon: 'arrow_back' },
    { move: TaskNavMove.Right, icon: 'arrow_forward' },
  ];
  comes_from_move = signal<TaskNavMove | null>(this.data.comes_from_move ?? null);
  goes_to_move = signal<TaskNavMove | null>(null);
  private readonly host_el = inject(ElementRef<HTMLElement>);
  private readonly dialog_nav_animation_ms = 300;

  initial_snapshot_product_task_origin_category_id: number | null = null;
  private product_task_origin_category_snapshot_initialized: boolean = false;
  ui_product_task_origin_category_id: number | null = null;

  me: UserCompanyProduct = null as any;
  titleOriginalValue: string = '';
  descriptionOriginalValue: string = '';
  commentOriginalValue: string = '';
  tinyMceApiKey: string;
  company_product_epics: CompanyProductEpic[] | undefined;

  has_other_reviewer: boolean;
  is_task_column_selector_disabled: boolean;

  storyPointEstimationParsed: string = '0h';
  revisionStoryPointEstimationParsed: string = '0h';
  designStoryPointEstimationParsed: string = '0h';
  currentBoard: CompanyProductPhaseBoard | undefined;
  is_current_board_old_and_inactive: boolean = false;
  is_current_board_future: boolean = false;

  editingField: string = '';
  userControl: UntypedFormControl = new UntypedFormControl();
  production_team_users: UserCompanyProduct[] = [];
  all_team_users: { [key: number]: UserCompanyProduct } = {};
  company_product_teams: { [key: number]: CompanyProductTeam } = {};

  newComment: string = '';
  editingComment: any = null as any;
  readonly is_saving_comment = signal(false);
  files: File[] = [];
  hoveringAttachedFile: any = null as any;
  protected readonly attachment_max_file_size_bytes = 10 * 1024 * 1024;
  historyLogs: ProductTaskHistoryLog[];

  commentsFragmentFullyLoaded = false;
  commentsFragmentLoading = false;

  /** Se incrementa al iniciar una recarga completa para ignorar respuestas obsoletas de fragmentos relacionales. */
  private taskRelationFetchInvalidationToken = 0;
  historyFragmentFullyLoaded = false;
  historyFragmentLoading = false;
  distributionFragmentFullyLoaded = false;
  distributionFragmentLoading = false;
  workingTimesFragmentFullyLoaded = false;
  workingTimesFragmentLoading = false;
  private productTaskOriginCategoriesFetchStarted = false;
  isTaskLoaded: boolean = false;
  imFollowingTask: boolean = false;
  imTaskRequester: boolean = false;

  isClientBusiness: boolean = false;
  is_client = false;
  protected readonly ProductTaskTypeEnum = ProductTaskTypeEnum;
  protected readonly ProductTaskCommentOriginEnum = ProductTaskCommentOriginEnum;
  isProductionTeam: boolean = false;
  canArchiveOrDelete: boolean = false;

  private readonly user_permissions_request$ = (this.hasAuthoritativeUserPermissions(this.data.user_permissions)
    ? of(this.data.user_permissions as CompanyProductPhaseUserPermissions)
    : this.api.getCompanyProductPhaseUserPermissions(this.company_product_phase_id)
  ).pipe(shareReplay({ bufferSize: 1, refCount: true }));

  readonly user_permissions = toSignal(this.user_permissions_request$, {
    initialValue: this.hasAuthoritativeUserPermissions(this.data.user_permissions)
      ? (this.data.user_permissions as CompanyProductPhaseUserPermissions)
      : EMPTY_COMPANY_PRODUCT_PHASE_USER_PERMISSIONS,
  });

  company_product_phase_task_time_autocalc_settings: CompanyProductPhaseTaskTimeAutocalcSettingCustom[] = [];
  not_used_company_product_phase_task_time_autocalc_settings: CompanyProductPhaseTaskTimeAutocalcSettingCustom[] = [];

  virtualBudgets = signal<Array<VirtualBudgetConfig>>([
    { slug: 'product-design', isEnabled: true },
    { slug: 'review-task', isEnabled: true },
    { slug: 'task-time-tracking', isEnabled: true },
  ]);

  distribution_table: ProductTaskDistribution = null as any;

  productTaskRequestUserList: User[] = [];
  readonly create_user_option_value = '__create_user__';
  readonly listener_user_picker = this.createProductTaskUserPickerState();
  readonly requester_user_picker = this.createProductTaskUserPickerState();
  private product_company_id: number | null = null;
  private product_company_name: string | null = null;
  private is_opening_add_user_dialog = false;

  tinyMceInit = {
    automatic_uploads: true,
    statusbar: false,
    menubar: false,
    block_unsupported_drop: false,
    ui_mode: 'split' as const,
    file_picker_types: 'file image media',
  };

  tiny_mce_comment_init = {
    ...this.tinyMceInit,
    auto_focus: true as const,
  };

  backdropClicked: boolean = false;

  private readonly TAG_AUTOCOMPLETE_MIN_CHARS = 3;

  // Task tasks
  separatorKeysCodes: number[] = [ENTER, COMMA];
  tags_cntrl = new FormControl('');
  filtered_tags: Observable<string[]>;
  tags: string[] = [];
  tag_categories: ProductTaskTagCategory[] = [];
  @ViewChild('tagsInput') tagsInput: ElementRef<HTMLInputElement>;

  //Autofocus when edit field
  @ViewChild('editingInput', { static: false })
  set editingInput(element: ElementRef<HTMLTextAreaElement>) {
    if (element) {
      element.nativeElement.focus();
    }
  }

  estimation_template_data: SpinnerGroupData[] | undefined;

  private destroy_ref = inject(DestroyRef);
  private readonly bisual_setting = inject(BisualSettingService);
  private readonly utils = inject(UtilsService);
  private readonly pending_changes_guard = inject(PendingChangesGuard);

  constructor() {
    const data = this.data;

    this.pending_changes_guard.registerBeforeUnload(this, this.destroy_ref);

    this.initFilteredTagsListeners();
    this.initUserPickerFilters();
    data.backdropSignal$.pipe(takeUntilDestroyed(this.destroy_ref)).subscribe(() => {
      this.backdropClicked = true;
      this.close();
    });
  }

  async ngOnInit() {
    this.checkInputData();
    this.me = this.userService.getCurrentUser() as UserCompanyProduct;

    await Promise.all([
      this.fetchCompanyProductTeamsIfNeeded(),
      this.fetchMembers(),
      this.fetchCompanyProductPhaseAndEpicsIfNeeded(),
      this.fetchUserPermissions(),
    ]);

    this.loadEssentialTaskData();

    this.tinyMceApiKey = this.tinymce.getKey();

    this.listenEscapeKeyToCloseDialog();
    this.listenArrowKeysToNavigateTasks();
  }

  openIssueOriginAgentReasonDialog(origin: ProductTaskIssueOrigin): void {
    const reason = origin.agent_reason?.trim();
    if (!reason) {
      return;
    }

    this.dialog.open(TextDialogComponent, {
      width: '520px',
      data: {
        title: `Motivo del origen ${origin.origin_product_task?.code ?? ''}`.trim(),
        body: reason,
        dialog_close_button: 'Cerrar',
      },
    });
  }

  ngAfterViewInit(): void {
    const move = this.comes_from_move();
    if (!move) {
      return;
    }
    const surface = this.getDialogSurface();
    if (!surface) {
      return;
    }
    this.suppressMatDialogTransition();
    surface.style.opacity = '0';
    surface.style.transform = this.offscreenTransform(move);
    requestAnimationFrame(() => this.animateDialogSurface(move, false));
  }

  onActivityMenuChange(menu: 'all' | 'comments' | 'history' | 'worklog' | 'distribution' | 'deploys'): void {
    this.activeActivityMenu = menu;
    if (menu === 'comments' || menu === 'all') {
      this.loadCommentsFragment();
    }
    if (menu === 'history' || menu === 'all') {
      this.ensureHistoryFragmentLoaded();
    }
    if (menu === 'distribution' || menu === 'all') {
      void this.ensureDistributionFragmentLoaded();
    }
    if (menu === 'deploys') {
      if (this.taskDeploys.length === 0) {
        this.loadTaskDeploys();
      }

      return;
    }
  }

  onDeploysMenuClick(): void {
    this.onActivityMenuChange('deploys');
  }

  async copyTaskCodeToClipboard(): Promise<void> {
    await this.utils.copyTextToClipboard(this.task.code);

    this.snack.open('Código de la tarea copiado al portapapeles', 'Ok', { duration: 3000 });
  }

  async close(task_nav_move?: TaskNavMove): Promise<void> {
    this.goes_to_move.set(task_nav_move ? this.getOppositeMove(task_nav_move) : null);
    await this.persistPendingOriginCategoryIfNeeded();

    const can_close = this.pending_changes_guard.canDeactivate(this);

    if (can_close !== true) {
      return;
    }

    await this.playDialogLeaveAnimation();
    this.dialogRef.close({ task: this.task, task_nav_move });
  }

  canDeactivate(): boolean {
    if (!this.task) {
      return true;
    }

    return !this.hasUnsavedChanges();
  }

  async setEdittingComment(comment: ProductTaskComment) {
    this.commentOriginalValue = comment.content;
    this.editingComment = comment;
  }

  handleSelectorInputFocusout(event: any) {
    if (
      event.target.className.includes('mat-option') ||
      event.target.className.includes('profile-image') ||
      event.target.parentElement.className.includes('mat-option-text')
    ) {
      //dont close
    } else {
      this.editingField = '';
    }
  }

  async setEditingField(field: '' | 'title' | 'description' | 'creatingComment') {
    const is_field_of_board: boolean = false;
    const is_field_editable_by_everyone: boolean = field === '' || field === 'creatingComment';

    if (
      (!this.task.is_completed || field === 'creatingComment') &&
      !this.is_current_board_old_and_inactive &&
      // són els que tenen permissos
      (this.isProductionTeam || this.isClientBusiness) &&
      (is_field_editable_by_everyone ||
        (is_field_of_board ? this.user_permissions().can_edit_board : this.user_permissions().can_edit_backlog) ||
        (this.isClientBusiness && this.task.is_draft && this.task.creator_id === this.me.id))
    ) {
      this.editingField = field;
    }
  }

  async chooseNewAssignedUser(
    time_budget: ProductTaskBoardTimeBudgetCustom,
    user: UserCompanyProduct | null,
    evt: MatSelectChange | undefined = undefined
  ): Promise<void> {
    if (evt != null) {
      const matFormField = evt.source._elementRef.nativeElement.closest('mat-form-field');
      if (matFormField) {
        matFormField.classList.remove('mat-focused');
      }
    }

    const assigneeId = user != null ? user.id : null;
    const isVirtualBudget = time_budget.id === 0;
    const hadNullAssignee = !isVirtualBudget && time_budget.assignee_id == null;

    if (isVirtualBudget) {
      if (!this.user_permissions().can_edit_board) {
        return;
      }

      await this.getOrCreateBudget(time_budget, assigneeId);
      this.initIsTaskColumnSelectorDisabledAttribute();
    } else {
      time_budget.assignee = user;
      time_budget.assignee_id = assigneeId;

      this.api
        .updateProductTaskBoardTimeBudget(time_budget.id, { assignee_id: assigneeId })
        .pipe(takeUntilDestroyed(this.destroy_ref))
        .subscribe((data: ProductTaskBoardTimeBudget): void => {
          time_budget.assignee = user;
          time_budget.assignee_id = assigneeId;

          if (hadNullAssignee) {
            this.loadFullTaskData();
          } else {
            this.initSpinnerData();
            this.updateShowDeleteTimeBudget(time_budget);
            this.initIsTaskColumnSelectorDisabledAttribute();
          }
        });
    }
  }

  chooseNewPriority(priority: string) {
    this.task.priority = priority;
    this.updateTask();
  }

  removeFromBoard() {
    if (
      confirm(
        `¿Estás seguro que quieres eliminar la tarea "${this.task.title}" del board "${this.currentBoard!.title ?? '#' + this.currentBoard!.id}"? Si la tarea existe en otro tablero, no se movera al backlog. Si no existe en ningún otro tablero, ésta será movida al backlog.`
      )
    ) {
      const currentBoard = this.product_task_board();
      if (!currentBoard) return;
      this.api
        .deleteProductTaskBoard(currentBoard.id)
        .pipe(takeUntilDestroyed(this.destroy_ref))
        .subscribe(async (): Promise<void> => {
          await this.persistPendingOriginCategoryIfNeeded();

          this.dialogRef.close({ deleted: true });
        });
    }
  }

  public isColumnDisabled(destCol: CompanyProductPhaseBoardCol): boolean {
    const currentBoard = this.product_task_board();
    if (!currentBoard) return false;
    if (this.is_current_board_old_and_inactive) return true;

    const originSlug = currentBoard.company_product_phase_board_col?.company_product_phase_board_col_role?.slug ?? null;
    const destSlug = destCol.company_product_phase_board_col_role?.slug ?? null;

    if (this.is_current_board_future && UtilsService.columnMoveWouldCompleteBoardBudgets(originSlug, destSlug)) {
      return true;
    }

    return this.shouldBlockOrHide(originSlug, destSlug);
  }

  async changeColumn(company_product_phase_board_col_id: number) {
    const currentBoard = this.product_task_board();
    if (!currentBoard) return;
    const colOrigin: CompanyProductPhaseBoardCol = currentBoard.company_product_phase_board_col;
    const colDestination: CompanyProductPhaseBoardCol = this.currentBoard!.company_product_phase_board_cols!.find(
      col => col.id == company_product_phase_board_col_id
    ) as CompanyProductPhaseBoardCol;
    const updatedBoard = { ...currentBoard, company_product_phase_board_col_id };
    this.product_task_board.set(updatedBoard);

    const result = await CompanyProductPhaseBoardDetailComponent.checkAndAskIfTaskMoveIsValid(
      updatedBoard as ProductTaskBoard,
      colOrigin,
      colDestination,
      this.api,
      this.dialog,
      this.me.id
    );

    if (result.valid) {
      await this.updateCompanyProductBoardTask(
        { company_product_phase_board_col_id: company_product_phase_board_col_id, append: 'product_task.is_completed' },
        false,
        result.decline_reasons
      );

      CompanyProductPhaseBoardDetailComponent.handleTaskFromColumnToColumnDialogs(
        this.dialog,
        updatedBoard.id,
        colOrigin,
        colDestination,
        this.company_product_id,
        updatedBoard.product_task_id
      )?.subscribe((data: ProductTaskBoardCustom) => {
        if (
          colOrigin.company_product_phase_board_col_role.slug === 'deadlock' ||
          colDestination.company_product_phase_board_col_role.slug === 'deadlock'
        ) {
          this.commentsFragmentFullyLoaded = false;
          this.loadCommentsFragment();
        } else if (
          colOrigin.company_product_phase_board_col_role.slug === 'todo' &&
          colDestination.company_product_phase_board_col_role.slug === 'in-progress'
        ) {
          this.updateTaskBoardTimeBudgetsAssignee(data);
          this.updateBoardCategoryEstimationTemplateData(data);
        }
      });
    }
  }

  openIssue() {
    const dialogRef = this.dialog.open(CreateProductTaskDialogComponent, {
      width: '600px',
      data: {
        company_product_phase_id: this.task.company_product_phase_id,
        type: 'issue',
        company_product_phase_board_id: this.currentBoard?.id ?? null,
        company_product_id: this.company_product_id,
      },
    });

    dialogRef
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroy_ref))
      .subscribe(data => {
        if (data) {
          this.loadFullTaskData();
        }
      });
  }

  canPublishTask(): boolean {
    if (!this.task.is_draft) {
      return false;
    }

    return (
      this.user_permissions().can_mark_tasks_as_ready ||
      (this.user_permissions().can_only_create_issues && this.task.type === ProductTaskTypeEnum.ISSUE)
    );
  }

  publishTask() {
    if (!this.canPublishTask()) {
      return;
    }

    this.updateTask({ id: this.task.id, is_draft: false });
  }

  updateProductTaskOriginCategory(product_task_origin_category_id: number | null): void {
    if (this.initial_snapshot_product_task_origin_category_id !== null) {
      return;
    }

    this.ui_product_task_origin_category_id = product_task_origin_category_id;
  }

  private async persistPendingOriginCategoryIfNeeded(): Promise<void> {
    if (this.initial_snapshot_product_task_origin_category_id !== null) {
      return;
    }

    if (this.ui_product_task_origin_category_id === this.task.product_task_origin_category_id) {
      return;
    }

    const product_task = await firstValueFrom(
      this.api.updateTask({
        id: this.task.id,
        product_task_origin_category_id: this.ui_product_task_origin_category_id,
      })
    );

    this.task.product_task_origin_category_id = product_task.product_task_origin_category_id;

    this.task.product_task_origin_category = product_task.product_task_origin_category;

    this.ui_product_task_origin_category_id = this.task.product_task_origin_category_id;
  }

  updateTask(body: any = null, param: string = '') {
    body = { ...(body ?? this.task) };

    this.titleOriginalValue = this.task.title;
    this.descriptionOriginalValue = this.task.description;

    if (body.order_company_product_phase != null) delete body.order_company_product_phase;
    if (body.product_task_boards != null) delete body.product_task_boards;

    this.api
      .updateTask(body)
      .pipe(takeUntilDestroyed(this.destroy_ref))
      .subscribe(data => {
        if (param !== '') {
          if (param === 'is_hotfix') {
            this.task.is_hotfix = data.is_hotfix;
          } else if (param === 'needs_testing') {
            this.task.needs_testing = data.needs_testing;
          }
        }

        if ('is_draft' in body) {
          this.task.is_draft = data.is_draft;
        }

        this.editingField = '';
      });
  }

  private canChooseAssigneeForBudget(): boolean {
    if (this.task.is_completed) {
      return false;
    }

    return this.user_permissions().can_drag_in_board || this.user_permissions().can_edit_board;
  }

  private isReviewTaskBudget(
    budget: ProductTaskBoardTimeBudget | { id: number; budgetable_type?: string; budgetable?: WorkingTimeCategory }
  ): boolean {
    return (
      budget.budgetable_type === 'App\\Models\\WorkingTimeCategory' &&
      (budget as ProductTaskBoardTimeBudget).budgetable != null &&
      ((budget as ProductTaskBoardTimeBudget).budgetable as WorkingTimeCategory).slug === 'review-task'
    );
  }

  private applyReviewTaskWorkingTimeBudgetIdToPayload(
    payload: Record<string, unknown>,
    budget: ProductTaskBoardTimeBudget,
    workingTime: WorkingTime | null
  ): void {
    if (payload['review_task_product_task_board_time_budget_id'] != null) {
      return;
    }

    if (payload['review_task_product_task_board_time_budget_id'] === null) {
      return;
    }

    if (this.isReviewTaskBudget(budget)) {
      payload['review_task_product_task_board_time_budget_id'] = workingTime?.review_task_product_task_board_time_budget_id ?? budget.id;

      return;
    }

    payload['review_task_product_task_board_time_budget_id'] = null;
  }

  private getReviewTargetBudgetOptions(board: ProductTaskBoard): ProductTaskBoardTimeBudget[] {
    const target_slugs = ['product-design', 'task-time-tracking'] as const;
    const options: ProductTaskBoardTimeBudget[] = [];
    const board_budgets = board.product_task_board_time_budgets as ProductTaskBoardTimeBudgetCustom[];

    for (const slug of target_slugs) {
      const virtual_config = this.virtualBudgets().find((vb: VirtualBudgetConfig): boolean => vb.slug === slug);

      if (!virtual_config?.isEnabled) {
        continue;
      }

      const budget = board_budgets.find(
        (b: ProductTaskBoardTimeBudgetCustom): boolean =>
          b.id !== 0 && b.budgetable_type === 'App\\Models\\WorkingTimeCategory' && (b.budgetable as WorkingTimeCategory)?.slug === slug
      );

      if (budget != null) {
        options.push(budget);
      }
    }

    return options;
  }

  private getReviewTaskBoardTimeBudget(board: ProductTaskBoard): ProductTaskBoardTimeBudget | undefined {
    const virtual_config = this.virtualBudgets().find((vb: VirtualBudgetConfig): boolean => vb.slug === 'review-task');

    if (!virtual_config?.isEnabled) {
      return undefined;
    }

    const board_budgets = board.product_task_board_time_budgets as ProductTaskBoardTimeBudgetCustom[];

    return board_budgets.find(
      (b: ProductTaskBoardTimeBudgetCustom): boolean =>
        b.id !== 0 &&
        b.budgetable_type === 'App\\Models\\WorkingTimeCategory' &&
        (b.budgetable as WorkingTimeCategory)?.slug === 'review-task'
    );
  }

  async openTimeTrackingDialog(
    workingTime: WorkingTimeCustom | null = null,
    product_task_board_time_budget: ProductTaskBoardTimeBudgetCustom | any | undefined = undefined
  ): Promise<void> {
    if (workingTime != null && !workingTime.can_edit_or_delete) {
      this.showWorkingTimeEditDeleteBlockedSnackBar();
      return;
    }

    if (this.isProductionTeam) {
      const currentBoard = this.product_task_board();

      if (workingTime != null && currentBoard) {
        if (workingTime.review_task_product_task_board_time_budget_id != null) {
          product_task_board_time_budget = currentBoard.product_task_board_time_budgets.find(
            (budget: ProductTaskBoardTimeBudgetCustom): boolean => budget.id === workingTime.review_task_product_task_board_time_budget_id
          );
        }

        if (product_task_board_time_budget == null && workingTime.working_time_category?.slug === 'review-task') {
          product_task_board_time_budget = currentBoard.product_task_board_time_budgets.find(
            (budget: ProductTaskBoardTimeBudgetCustom): boolean =>
              budget.budgetable_type === 'App\\Models\\WorkingTimeCategory' &&
              (budget.budgetable as WorkingTimeCategory).slug === 'review-task'
          );
        }

        if (product_task_board_time_budget == null) {
          product_task_board_time_budget = currentBoard.product_task_board_time_budgets.find(
            (budget: ProductTaskBoardTimeBudgetCustom): boolean =>
              budget.budgetable_type === 'App\\Models\\WorkingTimeCategory' && budget.budgetable_id === workingTime.working_time_category_id
          );
        }
      }

      if (product_task_board_time_budget == null) {
        product_task_board_time_budget = {
          id: 0,
        };
      }

      const realBudget = await this.getOrCreateBudget(product_task_board_time_budget);

      let reviewTargetBudgetOptions: ProductTaskBoardTimeBudget[] | undefined;
      let reviewTaskBoardTimeBudget: ProductTaskBoardTimeBudget | undefined;

      if (currentBoard) {
        reviewTaskBoardTimeBudget = this.getReviewTaskBoardTimeBudget(currentBoard);
        reviewTargetBudgetOptions = this.getReviewTargetBudgetOptions(currentBoard);
      }

      const company_product = await firstValueFrom(
        this.api.getCompanyProduct(this.company_product_id.toString()).pipe(takeUntilDestroyed(this.destroy_ref))
      );

      const timeTrackingDialog = this.dialog.open(AddNewWorkingTimeDialogComponent, {
        width: '650px',
        data: {
          product_task_board: currentBoard,
          product_task_board_time_budget: realBudget,
          workingTime: workingTime,
          is_editing: workingTime != null,
          review_target_budget_options: reviewTargetBudgetOptions,
          review_task_board_time_budget: reviewTaskBoardTimeBudget,
          can_create_task_location: this.user_permissions().can_edit_backlog,
          company_id: company_product.company_id ?? undefined,
        },
      });

      firstValueFrom(timeTrackingDialog.afterClosed().pipe(takeUntilDestroyed(this.destroy_ref))).then(data => {
        if (data != null) {
          data.company_product_id = this.company_product_id;
          const currentBoard = this.product_task_board();
          if (currentBoard) {
            data.product_task_board_id = currentBoard.id;
          }
          data.type = 'work_register';
          this.applyReviewTaskWorkingTimeBudgetIdToPayload(data, realBudget, workingTime);
          if (workingTime != null) {
            firstValueFrom(this.api.updateWorkingTime(workingTime.id.toString(), data).pipe(takeUntilDestroyed(this.destroy_ref))).then(
              () => {
                this.loadFullTaskData();
              }
            );
          } else {
            firstValueFrom(this.api.createWorkingTime(data).pipe(takeUntilDestroyed(this.destroy_ref)))
              .then(() => {
                this.loadFullTaskData();
              })
              .catch((err: { error?: { error?: string } }) => {
                this.snack.open(err?.error?.error ?? 'Error al registrar el tiempo.', undefined, { duration: 6000 });
              });
          }
          this.employee.sendUpdateHoursTopMenu();
        }
      });
    }
  }

  deleteWorkingTime(working_time: WorkingTimeCustom) {
    if (!working_time.can_edit_or_delete) {
      this.showWorkingTimeEditDeleteBlockedSnackBar();
      return;
    }

    if (confirm(`¿Estás seguro que quieres eliminar el registro de tiempo "${working_time.description}"?`)) {
      this.api
        .deleteWorkingTime(working_time.id)
        .pipe(takeUntilDestroyed(this.destroy_ref))
        .subscribe(data => {
          this.loadFullTaskData();
        });
    }
  }

  private getWorkingTimeEditDeleteWindowHours(): number {
    return parseInt(this.bisual_setting.get('working-time-edit-delete-window-hours').value, 10);
  }

  private canEditOrDeleteWorkingTime(working_time: Pick<WorkingTime, 'created_at'>): boolean {
    const window_hours = this.getWorkingTimeEditDeleteWindowHours();

    return dayjs().isBefore(dayjs(working_time.created_at).add(window_hours, 'hour'));
  }

  private showWorkingTimeEditDeleteBlockedSnackBar(): void {
    const window_hours = this.getWorkingTimeEditDeleteWindowHours();

    this.snack.open(
      `No puedes editar o eliminar un registro de tiempo creado hace más de ${window_hours} hora${window_hours === 1 ? '' : 's'}.`,
      'Ok',
      { duration: 5000 }
    );
  }

  setEditingFieldOriginalValue(originalValue: string, type: string) {
    type === 'title' ? (this.titleOriginalValue = originalValue) : (this.descriptionOriginalValue = originalValue);
  }

  loadPartialTaskData(): void {
    this.ensureHistoryFragmentLoaded();
  }

  private fetchTaskForDetail(params: Record<string, string>): Observable<ProductTask> {
    if (typeof this.data.task_code_id === 'string') {
      return this.api.getTaskByCode(this.data.task_code_id, params);
    }

    return this.api.getTask(this.data.task_code_id as number, params);
  }

  private buildEssentialTaskParams(): Record<string, string> {
    const withRelations = [
      'product_task_origin_category',
      'product_task_issue_origins..origin_product_task',
      'originated_issue_origins..issue_product_task',
      'company_product_epic',
      'product_task_time_budgets..budgetable',
      'product_task_boards..company_product_phase_board_col..company_product_phase_board',
      'product_task_boards..company_product_phase_board_col..company_product_phase_board_col_role',
      'product_task_boards..product_task_board_time_budgets..budgetable',
      'product_task_boards..product_task_board_time_budgets..assignee',
      'attachments',
      'tags..tag',
      'product_task_listeners',
      'product_task_requesters',
      'creator',
    ].join(',');

    return {
      with: withRelations,
      append: 'is_completed',
      select:
        'product_task_issue_origins..origin_product_task.code|title|type,originated_issue_origins..issue_product_task.code|title|type',
      with_counts: 'product_task_design_links',
    };
  }

  private buildFullTaskParams(): Record<string, string> {
    return {
      with: `company_product_epic,product_task_origin_category,product_task_issue_origins..origin_product_task,originated_issue_origins..issue_product_task,product_task_time_budgets..budgetable,product_task_boards..company_product_phase_board_col..company_product_phase_board,product_task_boards..company_product_phase_board_col..company_product_phase_board_col_role,${this.PRODUCT_TASK_BOARD_CHILDREN_PARAMS},comments..user..current_working_contract..current_working_contract_variable_condition..department_categories,history_logs,attachments,tags,product_task_listeners,product_task_requesters,company_product_phase..company_product_phase_boards,product_task_design_links,creator`,
      append: 'is_completed',
      order_by: 'product_task_boards..product_task_board_time_budgets..working_times.created_at:desc',
      select:
        'product_task_issue_origins..origin_product_task.code|title|type,originated_issue_origins..issue_product_task.code|title|type',
      with_counts: 'product_task_design_links',
    };
  }

  private loadEssentialTaskData(): void {
    const params = this.buildEssentialTaskParams();
    this.fetchTaskForDetail(params)
      .pipe(takeUntilDestroyed(this.destroy_ref))
      .subscribe((data: ProductTask) => {
        void this.onGetTaskData(data, 'essential');
      });
  }

  private loadCommentsFragment(): void {
    if (this.commentsFragmentFullyLoaded || this.commentsFragmentLoading || !this.task?.id) {
      return;
    }
    this.commentsFragmentLoading = true;
    const tokenAtRequestStart = this.taskRelationFetchInvalidationToken;
    this.api
      .getProductTaskComments(this.task.id)
      .pipe(takeUntilDestroyed(this.destroy_ref))
      .subscribe({
        next: (comments: ProductTaskComment[]) => {
          if (tokenAtRequestStart !== this.taskRelationFetchInvalidationToken) {
            return;
          }
          this.task.comments = (Array.isArray(comments) ? comments : []).map(comment => this.commentToCommentCustom(comment));
          this.commentsFragmentFullyLoaded = true;
          this.commentsFragmentLoading = false;
        },
        error: () => {
          if (tokenAtRequestStart !== this.taskRelationFetchInvalidationToken) {
            return;
          }
          this.commentsFragmentLoading = false;
        },
      });
  }

  private ensureHistoryFragmentLoaded(): void {
    if (this.historyFragmentFullyLoaded || this.historyFragmentLoading || !this.task?.id) {
      return;
    }
    this.historyFragmentLoading = true;
    const tokenAtRequestStart = this.taskRelationFetchInvalidationToken;
    this.api
      .getProductTaskHistoryLogs(this.task.id)
      .pipe(takeUntilDestroyed(this.destroy_ref))
      .subscribe({
        next: (logs: ProductTaskHistoryLog[]) => {
          if (tokenAtRequestStart !== this.taskRelationFetchInvalidationToken) {
            return;
          }
          this.applyHistoryLogsFromApi(logs);
          this.historyFragmentFullyLoaded = true;
          this.historyFragmentLoading = false;
        },
        error: () => {
          if (tokenAtRequestStart !== this.taskRelationFetchInvalidationToken) {
            return;
          }
          this.historyFragmentLoading = false;
        },
      });
  }

  private async ensureDistributionFragmentLoaded(): Promise<void> {
    if (this.distributionFragmentFullyLoaded || this.distributionFragmentLoading || !this.task?.id) {
      return;
    }
    this.distributionFragmentLoading = true;
    const tokenAtRequestStart = this.taskRelationFetchInvalidationToken;
    try {
      const data = await firstValueFrom(
        this.api.getProductTaskCompanyProductPhaseBoards(this.task.id).pipe(takeUntilDestroyed(this.destroy_ref))
      );
      if (tokenAtRequestStart !== this.taskRelationFetchInvalidationToken) {
        return;
      }
      if (data.company_product_phase_boards) {
        if (!this.task.company_product_phase) {
          this.task.company_product_phase = { id: data.company_product_phase_id } as CompanyProductPhase;
        }
        this.task.company_product_phase.company_product_phase_boards = data.company_product_phase_boards;
      }
      await this.initDistributionTable();
      this.distributionFragmentFullyLoaded = true;
    } finally {
      this.distributionFragmentLoading = false;
    }
  }

  private async ensureWorkingTimesFragmentLoaded(): Promise<void> {
    if (this.workingTimesFragmentFullyLoaded || this.workingTimesFragmentLoading || !this.task?.id) {
      return;
    }
    this.workingTimesFragmentLoading = true;
    const tokenAtRequestStart = this.taskRelationFetchInvalidationToken;
    try {
      const workingTimes = await firstValueFrom(
        this.api.getProductTaskWorkingTimes(this.task.id).pipe(takeUntilDestroyed(this.destroy_ref))
      );
      if (tokenAtRequestStart !== this.taskRelationFetchInvalidationToken) {
        return;
      }
      this.mergeWorkingTimesIntoTaskBudgetsFromServer(Array.isArray(workingTimes) ? workingTimes : []);
      this.processWorkingTimes();
      this.workingTimesFragmentFullyLoaded = true;
    } finally {
      this.workingTimesFragmentLoading = false;
    }
  }

  createComment(): void {
    if (this.is_saving_comment()) {
      return;
    }

    const comment = {
      product_task_id: this.task.id,
      user_id: this.me.id,
      content: this.newComment,
      origin: ProductTaskCommentOriginEnum.NORMAL,
    };
    this.is_saving_comment.set(true);
    this.api
      .createComment(comment)
      .pipe(
        takeUntilDestroyed(this.destroy_ref),
        finalize(() => this.is_saving_comment.set(false))
      )
      .subscribe((data: ProductTaskComment): void => {
        this.task.comments = [this.commentToCommentCustom(data), ...this.task.comments];
        this.newComment = '';
        this.editingField = '';
      });
  }

  deleteComment(comment: any) {
    if (confirm(`¿Estás seguro que quieres eliminar el comentario?`)) {
      this.api
        .deleteComment(comment.id)
        .pipe(takeUntilDestroyed(this.destroy_ref))
        .subscribe(() => {
          this.task.comments = this.task.comments.filter(c => c.id !== comment.id);
        });
    }
  }

  updateComment(comment: any): void {
    if (this.is_saving_comment()) {
      return;
    }

    this.is_saving_comment.set(true);
    this.api
      .updateComment(comment)
      .pipe(
        takeUntilDestroyed(this.destroy_ref),
        finalize(() => this.is_saving_comment.set(false))
      )
      .subscribe(() => {
        this.task.comments.map(c => {
          if (c.id === comment.id) {
            c.content = comment.content;
          }
        });
        this.editingComment = null;
      });
  }

  onDragFile(event: NgxDropzoneChangeEvent): void {
    if (!this.user_permissions().can_edit_backlog) {
      return;
    }

    const rejected_count = event.rejectedFiles.length;

    if (rejected_count > 0) {
      this.snack.open(
        rejected_count === 1 ? 'El archivo supera el límite de 10 MB.' : `${rejected_count} archivos superan el límite de 10 MB.`,
        'OK',
        { duration: 3000 }
      );
    }

    if (this.task.attachments.length === 0) {
      this.task.attachments = [];
    }

    this.files.push(...event.addedFiles);
    this.uploadFiles(event.addedFiles);
  }

  deleteAttachedFile(file: any) {
    if (this.user_permissions().can_edit_backlog && confirm(`¿Estás seguro que quieres eliminar el archivo adjunto "${file.file_name}"?`)) {
      this.api
        .deleteAttachedTaskFile(this.task.id, file.id)
        .pipe(takeUntilDestroyed(this.destroy_ref))
        .subscribe((): void => {
          this.task.attachments = this.task.attachments.filter(f => f.id !== file.id);
        });
    }
  }

  onAttachmentClick(event: MouseEvent, file: AttachmentCustom): void {
    event.preventDefault();
    event.stopPropagation();
    this.previewAttachedFile(file);
  }

  previewAttachedFile(file: AttachmentCustom): void {
    const kind = file.preview_kind ?? this.attachmentPreviewKind(file);
    if (!kind) {
      return;
    }

    const is_browser_playable = file.is_browser_playable ?? this.isBrowserPlayableMedia(file, kind);
    if (file.id && this.task?.id && (kind === MediaPreviewKind.IMAGE || is_browser_playable)) {
      this.openAttachedFilePreviewFromApi(file, kind, is_browser_playable);
      return;
    }

    if (file.file_path) {
      this.openMediaPreview(file.file_path, kind, file.file_name, file.file_path, is_browser_playable, file.id);
    }
  }

  openMediaPreview(
    src: string,
    kind: MediaPreviewKind = MediaPreviewKind.IMAGE,
    alt?: string,
    download_url?: string,
    is_browser_playable: boolean = true,
    file_id?: number
  ) {
    return this.dialog.open(MediaPreviewDialogComponent, {
      data: {
        src,
        alt,
        kind,
        download_url,
        is_browser_playable,
        task_id: this.task?.id,
        file_id,
      },
      panelClass: 'media-preview-dialog-panel',
      backdropClass: 'media-preview-dialog-backdrop',
      width: '100vw',
      height: '100vh',
      maxWidth: '100vw',
      maxHeight: '100vh',
      autoFocus: false,
      restoreFocus: false,
    });
  }

  private matchesFileExtension(value: unknown, pattern: RegExp): boolean {
    if (typeof value !== 'string' || value === '') {
      return false;
    }
    const without_query = value.split('?')[0];
    return pattern.test(without_query);
  }

  private checkIfFileIsImage(name_or_path: string | undefined): boolean {
    return this.matchesFileExtension(name_or_path, /\.(jpg|jpeg|png|gif|webp)$/i);
  }

  private checkIfFileIsVideo(name_or_path: string | undefined): boolean {
    return this.matchesFileExtension(name_or_path, /\.(mp4|m4v|webm|mov|avi|mkv|wmv|flv|ogv|mpeg|mpg|3gp|qt)$/i);
  }

  private checkIfFileIsAudio(name_or_path: string | undefined): boolean {
    return this.matchesFileExtension(name_or_path, /\.(mp3|wav|m4a|aac|flac|wma|opus|weba|oga|ogg|aiff|aif|amr|mid|midi|caf)$/i);
  }

  private openAttachedFilePreviewFromApi(file: AttachmentCustom, kind: MediaPreviewKind, is_browser_playable: boolean): void {
    this.api
      .downloadAttachedTaskFile(this.task.id, file.id)
      .pipe(takeUntilDestroyed(this.destroy_ref))
      .subscribe({
        next: response => {
          const body = response.body;
          if (!body) {
            return;
          }
          const object_url = URL.createObjectURL(this.blobForMediaPreview(body, kind, file.file_name));
          this.openMediaPreview(object_url, kind, file.file_name, file.file_path, is_browser_playable, file.id)
            .afterClosed()
            .pipe(takeUntilDestroyed(this.destroy_ref))
            .subscribe(() => URL.revokeObjectURL(object_url));
        },
      });
  }

  private serializeAttachment(file: Attachment): AttachmentCustom {
    const preview_kind = this.attachmentPreviewKind(file);
    return {
      ...file,
      file_path_sanitized: (file as AttachmentCustom).file_path_sanitized,
      preview_kind,
      is_image: preview_kind === MediaPreviewKind.IMAGE,
      is_video: preview_kind === MediaPreviewKind.VIDEO,
      is_audio: preview_kind === MediaPreviewKind.AUDIO,
      can_preview: preview_kind !== null,
      is_browser_playable: preview_kind != null && this.isBrowserPlayableMedia(file, preview_kind),
    };
  }

  private serializeAttachments(files: Attachment[]): AttachmentCustom[] {
    return files.map(file => this.serializeAttachment(file));
  }

  checkIfFileCanBeDisplayed(file_name: any) {
    return file_name.match(/\.(jpg|jpeg|png|gif)$/i);
  }

  checkIfFileIsExcel(file_name: any) {
    return file_name.match(/\.(xls|xlsx)$/i);
  }

  checkIfFileIsCSV(file_name: any) {
    return file_name.match(/\.(csv)$/i);
  }

  checkIfFileIsPDF(file_name: any) {
    return file_name.match(/\.(pdf)$/i);
  }

  getFileNameExtension(file_name: any) {
    return file_name.split('.').pop().toLowerCase();
  }

  showAttachment(file: AttachmentCustom): void {
    const serialized_file = this.serializeAttachment(file);
    if (serialized_file.can_preview) {
      this.previewAttachedFile(serialized_file);
      return;
    }
    window.open(file.file_path, '_blank');
  }

  onTaskRichContentClick(event: MouseEvent, edit_field?: 'description'): void {
    if (this.tryOpenMediaPreviewFromEvent(event)) {
      return;
    }

    if (edit_field) {
      this.setEditingField(edit_field);
    }
  }

  openImagePreview(src: string, alt?: string): void {
    this.openMediaPreview(src, MediaPreviewKind.IMAGE, alt);
  }

  private attachmentPreviewKind(file: { file_name?: string; file_path?: string }): MediaPreviewKind | null {
    if (this.checkIfFileIsImage(file.file_name) || this.checkIfFileIsImage(file.file_path)) {
      return MediaPreviewKind.IMAGE;
    }
    if (this.checkIfFileIsVideo(file.file_name) || this.checkIfFileIsVideo(file.file_path)) {
      return MediaPreviewKind.VIDEO;
    }
    if (this.checkIfFileIsAudio(file.file_name) || this.checkIfFileIsAudio(file.file_path)) {
      return MediaPreviewKind.AUDIO;
    }
    return null;
  }

  private blobForMediaPreview(blob: Blob, kind: MediaPreviewKind, file_name?: string): Blob {
    if (blob.type && blob.type !== 'application/octet-stream') {
      return blob;
    }
    const extension = this.getFileExtension(file_name ?? '');
    const mime =
      kind === MediaPreviewKind.VIDEO
        ? this.videoMimeFromExtension(extension) || 'video/mp4'
        : kind === MediaPreviewKind.AUDIO
          ? this.audioMimeFromExtension(extension) || 'audio/mpeg'
          : this.imageMimeFromExtension(extension);
    return new Blob([blob], { type: mime });
  }

  private imageMimeFromExtension(extension: string): string {
    if (extension === 'png') {
      return 'image/png';
    }
    if (extension === 'gif') {
      return 'image/gif';
    }
    if (extension === 'webp') {
      return 'image/webp';
    }
    return 'image/jpeg';
  }

  private tryOpenMediaPreviewFromEvent(event: MouseEvent): boolean {
    const target = event.target;
    if (target instanceof HTMLVideoElement) {
      return this.openMediaPreviewFromElement(event, target, MediaPreviewKind.VIDEO);
    }
    if (target instanceof HTMLAudioElement) {
      return this.openMediaPreviewFromElement(event, target, MediaPreviewKind.AUDIO);
    }

    if (!(target instanceof HTMLImageElement)) {
      return false;
    }
    if (
      target.classList.contains('profile-image') ||
      target.classList.contains('task-type') ||
      target.classList.contains('task-item-icon')
    ) {
      return false;
    }

    const src = target.currentSrc || target.src;
    if (!src) {
      return false;
    }

    event.preventDefault();
    event.stopPropagation();
    this.openMediaPreview(src, MediaPreviewKind.IMAGE, target.alt);
    return true;
  }

  private openMediaPreviewFromElement(event: MouseEvent, element: HTMLMediaElement, kind: MediaPreviewKind): boolean {
    const src = element.currentSrc || element.src;
    if (!src) {
      return false;
    }
    event.preventDefault();
    event.stopPropagation();
    this.openMediaPreview(src, kind);
    return true;
  }

  addTag(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    event.chipInput!.clear();
    this.tags_cntrl.setValue(null);

    if (!value || this.isTagAlreadyOnTask(value)) {
      return;
    }

    const cached_tag_category = this.findTagCategoryByTitle(value);
    if (cached_tag_category) {
      this.attachTagCategoryToTask(cached_tag_category);
      return;
    }

    this.resolveTagCategoryAndAttach(value);
  }

  removeTag(tag: string): void {
    const index = this.tags.indexOf(tag);
    if (index >= 0) {
      const indexInTask = this.task.tags.findIndex((t: any) => t.tag.title === tag);
      if (indexInTask >= 0) {
        const tagId = this.task.tags[indexInTask].id;
        this.api
          .deleteTaskTag(tagId)
          .pipe(takeUntilDestroyed(this.destroy_ref))
          .subscribe(data => {
            this.task.tags.splice(indexInTask, 1);
            this.tags.splice(index, 1);
          });
      }
    }
  }

  selectedTag(event: MatAutocompleteSelectedEvent): void {
    const tag_category = this.findTagCategoryByTitle(event.option.viewValue);
    if (tag_category) {
      this.attachTagCategoryToTask(tag_category);
    }

    this.tagsInput.nativeElement.value = '';
    this.tags_cntrl.setValue(null);
  }

  archive(): void {
    this.api
      .archiveTasks({ tasks_ids: [this.task.id], new_status_archived: true })
      .pipe(takeUntilDestroyed(this.destroy_ref))
      .subscribe((): void => {
        this.task.is_archived = true;
      });
  }

  unarchive(): void {
    this.api
      .archiveTasks({ tasks_ids: [this.task.id], new_status_archived: false })
      .pipe(takeUntilDestroyed(this.destroy_ref))
      .subscribe((): void => {
        this.task.is_archived = false;
      });
  }

  async openDesignLinksCrudDialog(): Promise<void> {
    const design_links_count = (this.task as ProductTaskCustom).product_task_design_links_count ?? 0;
    let links = this.task.product_task_design_links ?? [];
    if (design_links_count > 0 && links.length === 0) {
      const task_with_links = await firstValueFrom(
        this.api.getTask(this.task.id, { with: 'product_task_design_links' }).pipe(takeUntilDestroyed(this.destroy_ref))
      );
      links = task_with_links.product_task_design_links ?? [];
      this.task.product_task_design_links = links;
    }

    const dialogRef = this.dialog.open(ProductTaskDesignLinksCrudDialog, {
      width: '1000px',
      data: {
        company_product_id: this.company_product_id,
        product_task_id: this.task.id,
        product_task_design_links: links,
      },
    });

    dialogRef.afterClosed().subscribe((data: ProductTaskDesignLink[] | undefined) => {
      if (data === undefined) return;

      this.task.product_task_design_links = data;
    });
  }

  async copyLink(): Promise<void> {
    const link = this.permissions.isWorker()
      ? `${environment.angular_url}/employees/development/company-products/${this.company_product_id}/phases/${this.data.company_product_phase_id}/${typeof this.data.company_product_phase_board_id !== 'string' ? 'boards/' + this.data.company_product_phase_board_id : 'backlog'}?selectedIssue=${this.task.code}`
      : this.permissions.isClient()
        ? `${environment.angular_url}/clients/company-products/${this.company_product_id}/phases${this.data.company_product_phase_id}/${typeof this.data.company_product_phase_board_id !== 'string' ? 'boards/' + this.data.company_product_phase_board_id : 'backlog'}?selectedIssue=${this.task.code}`
        : this.permissions.isPartner()
          ? `${environment.angular_url}/partners/company-products/${this.company_product_id}/phases${this.data.company_product_phase_id}/${typeof this.data.company_product_phase_board_id !== 'string' ? 'boards/' + this.data.company_product_phase_board_id : 'backlog'}?selectedIssue=${this.task.code}`
          : '';

    await this.utils.copyTextToClipboard(link);

    this.snack.open('¡Enlace copiado correctamente!', 'Ok', { duration: 3000 });
  }

  getProgressSpinnerValueByBudget(budget: ProductTaskBoardTimeBudgetCustom | ProductTaskTimeBudgetCustom): number {
    if ((budget as ProductTaskBoardTimeBudgetCustom).product_task_board_id != null) {
      const b: ProductTaskBoardTimeBudgetCustom = budget as ProductTaskBoardTimeBudgetCustom;
      if (b.time_in_seconds != null && b.time_in_seconds >= 0) {
        const prcnt = b.time_registered_in_seconds_for_client / b.time_in_seconds;
        if (prcnt > 1 || prcnt == 0) return 100;
        else return prcnt * 100;
      } else return 100;
    } else if ((budget as ProductTaskTimeBudgetCustom).product_task_id != null) {
      const b: ProductTaskTimeBudgetCustom = budget as ProductTaskTimeBudgetCustom;
      if (b.time_in_seconds != null && b.time_in_seconds >= 0) {
        const prcnt = b.time_registered_in_seconds_for_client / b.time_in_seconds;
        if (prcnt > 1 || prcnt == 0) return 100;
        else return prcnt * 100;
      } else return 100;
    } else return 100;
  }

  getProgressSpinnerDistributionTableValue(body: ProductTaskDistributionTableColumn) {
    if (body.time_to_do <= 0) return 100;
    else {
      const prcnt = body.time_done / body.time_to_do;
      if (prcnt > 1 || prcnt == 0) return 100;
      else return prcnt * 100;
    }
  }

  getProgressSpinnerDistributionTableClassList(body: ProductTaskDistributionTableColumn) {
    return {
      disabled: body.time_to_do <= 0,
      start: body.time_to_do > 0 && body.time_done <= body.time_to_do && !body.completed && body.time_done == 0,
      inprogress: body.time_to_do > 0 && body.time_done <= body.time_to_do && !body.completed && body.time_done > 0,
      finished: body.time_to_do > 0 && body.time_done <= body.time_to_do && body.completed,
      overtime: body.time_to_do > 0 && body.time_done > body.time_to_do,
    };
  }

  markCategoryAsActive(time_budget: ProductTaskBoardTimeBudgetCustom): void {
    const currentBoard = this.product_task_board();
    if (!currentBoard || time_budget.id === 0) {
      return;
    }

    this.api
      .updateProductTaskBoard(currentBoard.id, { active_product_task_board_time_budget_id: time_budget.id })
      .pipe(takeUntilDestroyed(this.destroy_ref))
      .subscribe(() => {
        const updatedBoard = {
          ...currentBoard,
          active_product_task_board_time_budget_id: time_budget.id,
          active_product_task_board_time_budget: time_budget,
        };
        this.product_task_board.set(updatedBoard);
        this.initSpinnerData();
      });
  }

  markCategoryAsInactive(): void {
    const currentBoard = this.product_task_board();
    if (!currentBoard) {
      return;
    }

    this.api
      .updateProductTaskBoard(currentBoard.id, { active_product_task_board_time_budget_id: null })
      .pipe(takeUntilDestroyed(this.destroy_ref))
      .subscribe(() => {
        const updatedBoard = {
          ...currentBoard,
          active_product_task_board_time_budget_id: undefined,
          active_product_task_board_time_budget: undefined,
        };
        this.product_task_board.set(updatedBoard);
        this.initSpinnerData();
      });
  }

  markCategoryAsCompleted(time_budget: ProductTaskBoardTimeBudgetCustom) {
    if (this.is_current_board_future) {
      return;
    }

    if (!confirm('¿Seguro que quieres marcar esta categoría como completada?')) {
      return;
    }

    this.api
      .updateProductTaskBoardTimeBudget(time_budget.id, { completed_by_user_id: this.me.id })
      .pipe(takeUntilDestroyed(this.destroy_ref))
      .subscribe((): void => {
        time_budget.completed_by_user_id = this.me.id;

        const current_board = this.product_task_board();

        const completed_budget_is_active = current_board && current_board.active_product_task_board_time_budget_id === time_budget.id;

        if (completed_budget_is_active) {
          this.product_task_board.set({
            ...current_board,
            active_product_task_board_time_budget_id: undefined,
            active_product_task_board_time_budget: undefined,
          });
        }

        this.initSpinnerData();
      });
  }

  markCategoryAsIncomplete(time_budget: ProductTaskBoardTimeBudgetCustom) {
    if (this.task.is_completed) {
      return;
    }

    if (!confirm('¿Seguro que quieres marcar esta categoría como no completada?')) {
      return;
    }

    this.api
      .updateProductTaskBoardTimeBudget(time_budget.id, { completed_by_user_id: null })
      .pipe(takeUntilDestroyed(this.destroy_ref))
      .subscribe(data => {
        time_budget.completed_by_user_id = undefined;
        this.initSpinnerData();
      });
  }

  markTaskBudgetAsCompleted(time_budget: ProductTaskTimeBudgetCustom) {
    if (!confirm('¿Seguro que quieres marcar esta categoría como completada?')) {
      return;
    }

    this.api
      .markProductTaskTimeBudgetAsCompleted(time_budget.id)
      .pipe(takeUntilDestroyed(this.destroy_ref))
      .subscribe(response => {
        time_budget.completed_by_user_id = response.product_task_time_budget.completed_by_user_id ?? this.me.id;
        this.task.is_completed = response.is_completed;
        this.processBudgets();
        this.initSpinnerData();
      });
  }

  markTaskBudgetAsUncompleted(time_budget: ProductTaskTimeBudgetCustom) {
    if (this.task.is_completed) {
      return;
    }

    if (!confirm('¿Seguro que quieres marcar esta categoría como no completada?')) {
      return;
    }

    this.api
      .markProductTaskTimeBudgetAsUncompleted(time_budget.id)
      .pipe(takeUntilDestroyed(this.destroy_ref))
      .subscribe(response => {
        time_budget.completed_by_user_id = response.product_task_time_budget.completed_by_user_id;
        this.task.is_completed = response.is_completed;
        this.processBudgets();
        this.initSpinnerData();
      });
  }

  removeListener(listener: User): void {
    if (!listener?.id || this.is_current_board_old_and_inactive) {
      return;
    }

    this.api
      .unlistenTask(this.task.id, listener.id)
      .pipe(takeUntilDestroyed(this.destroy_ref))
      .subscribe(() => {
        this.task.product_task_listeners = (this.task.product_task_listeners ?? []).filter(existing => existing.id !== listener.id);
        this.listener_user_picker.control.setValue(this.listener_user_picker.control.value);
        if (listener.id === this.me.id) {
          this.imFollowingTask = false;
        }
      });
  }

  addListener(user: User): void {
    if (!user?.id || this.is_current_board_old_and_inactive) {
      return;
    }

    const already_added = (this.task.product_task_listeners ?? []).some(listener => listener.id === user.id);
    this.listener_user_picker.control.setValue(null);

    if (already_added) {
      return;
    }

    this.api
      .listenTask(this.task.id, user.id)
      .pipe(takeUntilDestroyed(this.destroy_ref))
      .subscribe(() => {
        this.task.product_task_listeners = [...(this.task.product_task_listeners ?? []), user];
        this.listener_user_picker.control.setValue(null);
        if (user.id === this.me.id) {
          this.imFollowingTask = true;
        }
      });
  }

  getAssigneeFromBudget(user: User | null): User {
    return user as User;
  }

  getBudgetableSlug(budgetable: WorkingTimeCategory | CompanyProductTeam) {
    if ((budgetable as WorkingTimeCategory).slug != null) return (budgetable as WorkingTimeCategory).slug;
    else return '';
  }

  deleteTaskBudget(time_budget: ProductTaskBoardTimeBudget) {
    if (confirm(`¿Estás seguro que quieres que no se va a realizar trabajo de "${time_budget.budgetable.name}" en este board?`)) {
      this.api
        .deleteProductTaskBoardTimeBudget(time_budget.id)
        .pipe(takeUntilDestroyed(this.destroy_ref))
        .subscribe(data => {
          const boardWasDeletedBecauseItWasTheLastBudget = data?.board_was_deleted === true;

          if (boardWasDeletedBecauseItWasTheLastBudget) {
            void (async (): Promise<void> => {
              await this.persistPendingOriginCategoryIfNeeded();

              this.dialogRef.close({ deleted: true });
            })();
          } else {
            this.loadFullTaskData();
          }
        });
    }
  }

  reRequestProductTaskBoardReview(product_task_board: ProductTaskBoard) {
    this.api
      .reRequestProductTaskBoardReview(product_task_board.id)
      .pipe(takeUntilDestroyed(this.destroy_ref))
      .subscribe(data => {
        const currentBoard = this.product_task_board();
        if (currentBoard) {
          const updatedBoard = { ...currentBoard, request_review_available: data.request_review_available };
          this.product_task_board.set(updatedBoard);
        }
      });
  }

  isReRequestReviewDisabled(productTaskBoard: ProductTaskBoard | undefined): boolean {
    if (!productTaskBoard) {
      return true;
    }

    return !productTaskBoard.request_review_available || this.is_current_board_old_and_inactive;
  }

  getReRequestReviewDisabledReason(productTaskBoard: ProductTaskBoard | undefined): string {
    if (!this.isReRequestReviewDisabled(productTaskBoard)) {
      return '';
    }

    if (this.is_current_board_old_and_inactive) {
      return 'No se puede solicitar revisión porque este board está inactivo.';
    }

    if (this.wasReviewerAssignedInLast24Hours(productTaskBoard)) {
      return 'No se puede solicitar revisión porque se ha asignado un revisor hace menos de 24 horas.';
    }

    return 'No se puede solicitar revisión porque ya se pidió una revisión hace menos de 24 horas.';
  }

  private wasReviewerAssignedInLast24Hours(productTaskBoard: ProductTaskBoard | undefined): boolean {
    if (!productTaskBoard) {
      return false;
    }

    const reviewTaskBudget = productTaskBoard.product_task_board_time_budgets.find(
      budget =>
        budget.budgetable_type === 'App\\Models\\WorkingTimeCategory' && (budget.budgetable as WorkingTimeCategory).slug === 'review-task'
    );

    if (!reviewTaskBudget?.assignee_id || !reviewTaskBudget.updated_at) {
      return false;
    }

    const lastUpdate = dayjs(reviewTaskBudget.updated_at);
    if (!lastUpdate.isValid()) {
      return false;
    }

    return dayjs().diff(lastUpdate, 'hour') < 24;
  }

  private getRoleStringFromWcvc(wcvc: WorkingContractVariableCondition): string {
    return wcvc.department_categories.map(dc => dc.name).join(', ');
  }

  private commentToCommentCustom(comment: ProductTaskComment): ProductTaskCommentCustom {
    const team_user = this.all_team_users[comment.user.id];
    if (team_user !== undefined) {
      (comment as ProductTaskCommentCustom).author_role =
        team_user.company_product_user_member !== undefined
          ? team_user.company_product_user_member.company_product_user_member_role.name
          : `Cliente - ${team_user.client_role}`;
      return comment as ProductTaskCommentCustom;
    }

    const wcvc = comment.user.current_working_contract?.current_working_contract_variable_condition;
    (comment as ProductTaskCommentCustom).author_role =
      wcvc?.department_categories !== undefined && wcvc.department_categories.length > 0
        ? this.getRoleStringFromWcvc(wcvc)
        : 'Rol desconocido';

    return comment as ProductTaskCommentCustom;
  }

  addRequester(user: User): void {
    if (!user?.id || this.is_current_board_old_and_inactive || this.is_client) {
      return;
    }

    const already_added = (this.task.product_task_requesters ?? []).some(requester => requester.id === user.id);
    this.requester_user_picker.control.setValue(null);

    if (already_added) {
      return;
    }

    this.api.attachProductTaskRequester(this.task.id, user.id).subscribe({
      next: () => {
        this.task.product_task_requesters = [...(this.task.product_task_requesters ?? []), user];
        this.requester_user_picker.control.setValue(null);
        if (user.id === this.me.id) {
          this.imTaskRequester = true;
        }
      },
    });
  }

  removeRequester(user: User): void {
    if (!user?.id || this.is_current_board_old_and_inactive || this.is_client) {
      return;
    }

    this.api.detachProductTaskRequester(this.task.id, user.id).subscribe({
      next: () => {
        this.task.product_task_requesters = (this.task.product_task_requesters ?? []).filter(requester => requester.id !== user.id);
        this.requester_user_picker.control.setValue(this.requester_user_picker.control.value);
        if (user.id === this.me.id) {
          this.imTaskRequester = false;
        }
      },
    });
  }

  onUserPickerSelected(picker_key: ProductTaskUserPickerKey, event: MatAutocompleteSelectedEvent): void {
    const picker = this.getUserPicker(picker_key);

    if (event.option.value === this.create_user_option_value) {
      picker.control.setValue(picker.create_typed_name, { emitEvent: false });
      this.openAddUserDialogForPicker(picker_key);
      return;
    }

    if (picker_key === 'listeners') {
      this.addListener(event.option.value as User);
      return;
    }

    this.addRequester(event.option.value as User);
  }

  openAddUserDialogForPicker(picker_key: ProductTaskUserPickerKey): void {
    if (this.is_current_board_old_and_inactive || !this.user_permissions().can_edit_backlog || this.is_opening_add_user_dialog) {
      return;
    }

    const picker = this.getUserPicker(picker_key);
    const typed_name = picker.create_typed_name || this.getUserPickerTypedName(picker);
    if (typed_name.length < 3) {
      return;
    }

    const open_dialog = (): void => {
      if (!this.product_company_id) {
        this.snack.open('No se ha podido cargar la empresa del producto', 'Ok', { duration: 4000 });
        return;
      }

      this.is_opening_add_user_dialog = true;
      this.dialog
        .open(AddUserDialogComponent, {
          width: '750px',
          data: this.buildClientUserDialogData(typed_name),
        })
        .afterClosed()
        .subscribe((user: User | null | undefined): void => {
          this.is_opening_add_user_dialog = false;
          if (!user?.id) {
            return;
          }

          this.ensureUserInAutocompleteList(user);
          if (picker_key === 'listeners') {
            this.addListener(user);
          } else {
            this.addRequester(user);
          }
          picker.create_typed_name = '';
        });
    };

    if (this.product_company_id) {
      open_dialog();
      return;
    }

    this.api.getCompanyProduct(this.company_product_id.toString(), { with: 'company' }).subscribe({
      next: (company_product: CompanyProduct): void => {
        this.cacheProductCompany(company_product);
        open_dialog();
      },
      error: (): void => {
        this.snack.open('No se ha podido cargar la empresa del producto', 'Ok', { duration: 4000 });
      },
    });
  }

  createBudget(ppttasc: CompanyProductPhaseTaskTimeAutocalcSettingCustom) {
    const currentBoard = this.product_task_board();
    if (currentBoard) {
      this.api
        .createProductTaskBoardTimeBudget({
          product_task_board_id: currentBoard.id,
          budgetable_type: 'App\\Models\\WorkingTimeCategory',
          budgetable_id: ppttasc.company_product_phase_task_time_autocalc_setting_category.working_time_category_id,
          time_in_seconds: 3600,
        } as ProductTaskBoardTimeBudget)
        .pipe(takeUntilDestroyed(this.destroy_ref))
        .subscribe(data => {
          this.loadFullTaskData();
        });
    }
  }

  private async getOrCreateBudget(
    virtualBudget: ProductTaskBoardTimeBudgetCustom,
    assigneeId?: number | null
  ): Promise<ProductTaskBoardTimeBudgetCustom> {
    if (virtualBudget.id !== 0) {
      return virtualBudget;
    }

    if (!this.user_permissions().can_edit_board) {
      return virtualBudget;
    }

    const currentBoard = this.product_task_board();
    if (currentBoard) {
      const budgetData: any = {
        product_task_board_id: currentBoard.id,
        budgetable_type: virtualBudget.budgetable_type,
        budgetable_id: virtualBudget.budgetable_id,
        time_in_seconds: 0,
      };

      if (assigneeId != null) {
        budgetData.assignee_id = assigneeId;
      }

      const createdBudget = await firstValueFrom(
        this.api.createProductTaskBoardTimeBudget(budgetData as ProductTaskBoardTimeBudget).pipe(takeUntilDestroyed(this.destroy_ref))
      );

      if (createdBudget) {
        let assigneeUser: UserCompanyProduct | null = null;
        if (assigneeId != null) {
          assigneeUser = this.production_team_users.find((u: UserCompanyProduct): boolean => u.id === assigneeId) || null;
        }

        // update the virtual budget with the data of the created real budget
        virtualBudget.id = createdBudget.id;
        virtualBudget.time_in_seconds = createdBudget.time_in_seconds || 0;
        virtualBudget.assignee_id = createdBudget.assignee_id || assigneeId || null;
        virtualBudget.assignee = assigneeUser || (createdBudget.assignee as UserCompanyProduct) || null;
        virtualBudget.completed_by_user_id = createdBudget.completed_by_user_id || undefined;

        // update the created budget with the assignee if we have it
        const budgetToAdd = createdBudget as ProductTaskBoardTimeBudgetCustom;
        if (assigneeUser) {
          budgetToAdd.assignee = assigneeUser;
          budgetToAdd.assignee_id = assigneeId ?? null;
        }

        const currentBoard = this.product_task_board();
        if (currentBoard) {
          const budgetExists = currentBoard.product_task_board_time_budgets.find(
            (b: ProductTaskBoardTimeBudgetCustom): boolean => b.id === createdBudget.id
          );

          if (!budgetExists) {
            const updatedBoard = {
              ...currentBoard,
              product_task_board_time_budgets: [...currentBoard.product_task_board_time_budgets, budgetToAdd],
            };
            this.product_task_board.set(updatedBoard);
          }
        }

        this.loadFullTaskData();

        return budgetToAdd;
      }
    }

    return virtualBudget;
  }

  detachCompanyProductEpic() {
    this.task.company_product_epic_id = null;
    this.task.company_product_epic = null;
    this.updateTask({ id: this.task.id, company_product_epic_id: null });
  }

  onClickCreateNewEpic() {
    const dialogRef = this.dialog.open(InputDialogComponent, {
      width: '300px',
      data: {
        title: 'Título de nuevo epic',
        description: `Introduce el título del nuevo epic.`,
        type: 'text',
        placeholder: 'Título de ejemplo...',
        label: 'Nuevo título',
        close_button_text: 'Crear epic',
      },
    });

    dialogRef
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroy_ref))
      .subscribe(data => {
        if (data) {
          this.api
            .createCompanyProductEpic({
              name: data,
              company_product_id: this.company_product_id,
            } as CompanyProductEpic)
            .pipe(takeUntilDestroyed(this.destroy_ref))
            .subscribe(data => {
              this.company_product_epics?.push(data);
              this.task.company_product_epic = data;
              this.task.company_product_epic_id = data.id;
              this.updateTask({ id: this.task.id, company_product_epic_id: data.id });
            });
        }
      });
  }

  changeCompanyProductEpic(company_product_epic_id: number) {
    this.task.company_product_epic_id = company_product_epic_id;
    this.task.company_product_epic = this.company_product_epics?.find(e => e.id == company_product_epic_id);
    this.updateTask({ id: this.task.id, company_product_epic_id: company_product_epic_id });
  }

  private listenEscapeKeyToCloseDialog(): void {
    this.dialogRef
      .keydownEvents()
      .pipe(
        filter((e: KeyboardEvent): boolean => e.key === 'Escape'),
        takeUntilDestroyed(this.destroy_ref)
      )
      .subscribe((e: KeyboardEvent): void => {
        if (this.dialog.openDialogs.length > 1) {
          return;
        }
        e.preventDefault();
        e.stopPropagation();
        void this.close();
      });
  }

  private listenArrowKeysToNavigateTasks(): void {
    this.dialogRef
      .keydownEvents()
      .pipe(
        filter((e: KeyboardEvent): boolean => ['ArrowLeft', 'ArrowUp', 'ArrowRight', 'ArrowDown'].includes(e.key)),
        takeUntilDestroyed(this.destroy_ref)
      )
      .subscribe((e: KeyboardEvent): void => {
        if (!this.canNavigateTasksWithKeyboard(e)) {
          return;
        }
        e.preventDefault();
        e.stopPropagation();
        const move: TaskNavMove = e.key.toLowerCase().replace('arrow', '') as TaskNavMove;
        void this.goToTask(move);
      });
  }

  private canNavigateTasksWithKeyboard(event: KeyboardEvent): boolean {
    if (event.repeat || event.altKey || event.ctrlKey || event.metaKey) {
      return false;
    }
    if (this.dialog.openDialogs[this.dialog.openDialogs.length - 1] !== this.dialogRef) {
      return false;
    }
    if (this.editingField) {
      return false;
    }

    const target = (event.target as HTMLElement | null) ?? (document.activeElement as HTMLElement | null);
    if (!target) {
      return true;
    }
    if (target instanceof HTMLInputElement || target instanceof HTMLTextAreaElement || target instanceof HTMLSelectElement) {
      return false;
    }
    if (target.isContentEditable) {
      return false;
    }

    return !target.closest(
      'input, textarea, select, option, [contenteditable="true"], mat-select, mat-option, mat-chip-grid, .mat-mdc-select-panel, .mat-mdc-autocomplete-panel, .mat-mdc-menu-panel, .mat-datepicker-content, .tox-tinymce'
    );
  }

  private hasUnsavedChanges(): boolean {
    return (
      this.task.title !== this.titleOriginalValue ||
      this.task.description !== this.descriptionOriginalValue ||
      (this.editingComment && this.editingComment.content !== this.commentOriginalValue) ||
      this.newComment !== ''
    );
  }

  private saveChanges(): void {
    if (this.editingField === 'creatingComment' || this.newComment !== '') {
      this.newComment.length > 0
        ? this.createComment()
        : this.snack.open('Comentario demasiado corto cómo para guardarlo', 'Ok', { duration: 5000 });
    }
    if (['title', 'description'].includes(this.editingField)) {
      this.updateTask();
    }
    if (this.editingComment) {
      this.editingComment.content !== ''
        ? this.updateComment(this.editingComment)
        : this.snack.open('Comentario vacío, no se han guardado los cambios', 'Ok', { duration: 5000 });
    }
  }

  private async fetchMembers() {
    const [users, data, company_product] = await Promise.all([
      firstValueFrom(
        this.api.getCompanyProductActiveProductionTeam(this.company_product_id.toString()).pipe(takeUntilDestroyed(this.destroy_ref))
      ),
      firstValueFrom(
        this.api.getActiveCompanyProductMembersWithBusiness(this.company_product_id.toString()).pipe(takeUntilDestroyed(this.destroy_ref))
      ),
      firstValueFrom(
        this.api.getCompanyProduct(this.company_product_id.toString(), { with: 'company' }).pipe(
          takeUntilDestroyed(this.destroy_ref),
          catchError(() => of(null))
        )
      ),
    ]);

    if (company_product) {
      this.cacheProductCompany(company_product);
    }

    // Solicitado por: product team (workers + partners) + users with company_id of the product company.
    const requestUsersById = new Map<number, User>();

    if (users) {
      this.production_team_users = users.bisual_users.map((obj: CompanyProductUserMember) => {
        const u: UserCompanyProduct = obj.user as UserCompanyProduct;
        const company_product_user_member: CompanyProductUserMember = { ...obj };
        delete (company_product_user_member as any).user;
        u.company_product_user_member = company_product_user_member;
        return u;
      });
      users.company_users.forEach(cu => {
        this.production_team_users.push(cu as UserCompanyProduct);
      });
    }

    if (data) {
      this.all_team_users = {};
      data.bisual_users.forEach(bu => {
        const u: UserCompanyProduct = bu.user as UserCompanyProduct;
        const company_product_user_member: CompanyProductUserMember = { ...bu };
        delete (company_product_user_member as any).user;
        u.company_product_user_member = company_product_user_member;

        this.all_team_users[bu.user.id] = u;
        if (bu.user) {
          requestUsersById.set(bu.user.id, bu.user);
        }
      });
      data.company_users.forEach(cu => {
        this.all_team_users[cu.id] = cu as UserCompanyProduct;
        requestUsersById.set(cu.id, cu);
      });
    }

    this.productTaskRequestUserList = this.sortUserPickerCandidates([...requestUsersById.values()]);
    this.listener_user_picker.control.setValue(this.listener_user_picker.control.value ?? '');
    this.requester_user_picker.control.setValue(this.requester_user_picker.control.value ?? '');
  }

  private shouldBlockOrHide(originSlug: string | null, destSlug: string | null): boolean {
    if (!originSlug) return false;

    switch (originSlug) {
      case 'todo':
        return !['in-progress', 'deadlock', 'todo'].includes(destSlug ?? '');

      case 'in-progress':
        return !['under-review', 'todo', 'deadlock', 'in-progress'].includes(destSlug ?? '');

      case 'deadlock':
        return !['todo', 'in-progress', 'under-review', 'deadlock'].includes(destSlug ?? '');

      case 'under-review':
        const currentBoard = this.product_task_board();
        if (currentBoard && CompanyProductPhaseBoardDetailComponent.hasPendingDevBudget(currentBoard)) {
          return !['in-progress', 'deadlock', 'under-review', 'todo'].includes(destSlug ?? '');
        } else {
          return !['in-progress', 'deadlock', 'under-review', 'test', 'done'].includes(destSlug ?? '');
        }

      case 'test':
        return !['test', 'done'].includes(destSlug ?? '');

      case 'done':
        const currentBoardDone = this.product_task_board();
        if (currentBoardDone && !CompanyProductPhaseBoardDetailComponent.hasPendingBudget(currentBoardDone))
          return !['done'].includes(destSlug ?? '');
        else return !['todo'].includes(destSlug ?? '');

      default:
        return false;
    }
  }

  private async updateCompanyProductBoardTask(body: any = null, refresh: boolean = false, decline_reasons: number[] = []) {
    // pasar un query param amb el slug
    const currentBoard = this.product_task_board();
    if (!currentBoard) return;
    body = body ?? currentBoard;
    const data = await firstValueFrom(
      this.api.updateProductTaskBoard(currentBoard.id, body, decline_reasons).pipe(takeUntilDestroyed(this.destroy_ref))
    );
    if (data) {
      // Actualitzem per porcions, manualment
      if ('company_product_phase_board_col_id' in body) {
        const updatedBoard = {
          ...currentBoard,
          order_column: data.order_column,
          company_product_phase_board_col_id: data.company_product_phase_board_col_id,
          company_product_phase_board_col: this.currentBoard!.company_product_phase_board_cols!.find(
            c => c.id === data.company_product_phase_board_col_id
          )!,
          product_task_board_time_budgets: currentBoard.product_task_board_time_budgets.map((budget: ProductTaskBoardTimeBudgetCustom) => {
            const updated_budget: ProductTaskBoardTimeBudgetCustom = data.product_task_board_time_budgets.find(
              (b: ProductTaskBoardTimeBudget) => b.id === budget.id
            ) as ProductTaskBoardTimeBudgetCustom;
            if (updated_budget?.completed_by_user_id != null) {
              return {
                ...budget,
                completed_by_user_id: updated_budget.completed_by_user_id,
              };
            }
            return budget;
          }),
          product_task: {
            ...currentBoard.product_task,
            is_completed: data.product_task?.is_completed ?? false,
          },
        };

        if (updatedBoard.product_task?.is_completed) {
          this.task.is_completed = true;
        }

        this.product_task_board.set(updatedBoard);
        this.initHasOtherReviewerAttribute(updatedBoard.product_task_board_time_budgets);
        this.initActiveTimeBudget();
        this.processBudgets();
      }
      // Altres updates...
    }

    if (refresh) {
      this.loadFullTaskData();
    } else {
      this.initIsTaskColumnSelectorDisabledAttribute();
      this.initSpinnerData();
    }
  }

  private loadFullTaskData(): void {
    this.taskRelationFetchInvalidationToken++;
    this.commentsFragmentLoading = false;
    this.historyFragmentLoading = false;
    this.distributionFragmentLoading = false;
    this.workingTimesFragmentLoading = false;
    const params = this.buildFullTaskParams();
    this.fetchTaskForDetail(params)
      .pipe(takeUntilDestroyed(this.destroy_ref))
      .subscribe((data: ProductTask) => {
        void this.onGetTaskData(data, 'full');
      });
  }

  openTaskTimeBudgetDialog(): void {
    if (this.is_current_board_old_and_inactive || !this.user_permissions().can_edit_backlog) {
      return;
    }

    const board = this.product_task_board();
    const dialogData = {
      task: {
        id: this.task.id,
        product_task_time_budgets: this.task.product_task_time_budgets ?? [],
      },
      product_task_board: board
        ? {
            id: board.id,
            product_task_board_time_budgets: board.product_task_board_time_budgets ?? [],
          }
        : undefined,
      company_product_phase_task_time_autocalc_settings: this.company_product_phase_task_time_autocalc_settings ?? [],
    } as TaskTimeBudgetDialogData;
    this.dialog
      .open(TaskTimeBudgetDialogComponent, { data: dialogData, width: '500px' })
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroy_ref))
      .subscribe((saved: boolean) => {
        if (saved) {
          this.loadFullTaskData();
        }
      });
  }

  private uploadFiles(files: File[]) {
    const allowed_files = this.filterAllowedAttachmentFiles(files);
    if (allowed_files.length === 0) {
      return;
    }

    this.api.attachTaskFiles(this.task.id, allowed_files).subscribe({
      next: data => this.task.attachments.push(...this.serializeAttachments(data)),
    });
  }

  private filterAllowedAttachmentFiles(files: File[]): File[] {
    const oversized_files = files.filter(file => file.size > this.attachment_max_file_size_bytes);
    if (oversized_files.length > 0) {
      this.snack.open(
        oversized_files.length === 1
          ? 'El archivo supera el límite de 10 MB.'
          : `${oversized_files.length} archivos superan el límite de 10 MB.`,
        'OK',
        { duration: 3000 }
      );
    }

    return files.filter(file => file.size <= this.attachment_max_file_size_bytes);
  }

  private isBrowserPlayableMedia(file: { file_name?: string; file_path?: string }, kind: MediaPreviewKind): boolean {
    if (kind === MediaPreviewKind.IMAGE) {
      return true;
    }
    return this.isBrowserPlayableMediaName(file.file_name, kind) || this.isBrowserPlayableMediaName(file.file_path, kind);
  }

  private isBrowserPlayableMediaName(name_or_path: string | undefined, kind: MediaPreviewKind): boolean {
    const mime =
      kind === MediaPreviewKind.VIDEO
        ? this.videoMimeFromExtension(this.getFileExtension(name_or_path ?? ''))
        : this.audioMimeFromExtension(this.getFileExtension(name_or_path ?? ''));
    if (!mime) {
      return false;
    }
    const element = kind === MediaPreviewKind.VIDEO ? document.createElement('video') : document.createElement('audio');
    return element.canPlayType(mime) !== '';
  }

  private videoMimeFromExtension(extension: string): string {
    switch (extension) {
      case 'mp4':
      case 'm4v':
        return 'video/mp4';
      case 'webm':
        return 'video/webm';
      case 'ogv':
        return 'video/ogg';
      case 'mov':
      case 'qt':
        return 'video/quicktime';
      case 'avi':
        return 'video/x-msvideo';
      case 'mkv':
        return 'video/x-matroska';
      case 'wmv':
        return 'video/x-ms-wmv';
      case 'flv':
        return 'video/x-flv';
      case 'mpeg':
      case 'mpg':
        return 'video/mpeg';
      case '3gp':
        return 'video/3gpp';
      default:
        return '';
    }
  }

  private audioMimeFromExtension(extension: string): string {
    switch (extension) {
      case 'mp3':
        return 'audio/mpeg';
      case 'wav':
        return 'audio/wav';
      case 'm4a':
        return 'audio/mp4';
      case 'aac':
        return 'audio/aac';
      case 'flac':
        return 'audio/flac';
      case 'wma':
        return 'audio/x-ms-wma';
      case 'opus':
        return 'audio/opus';
      case 'weba':
        return 'audio/webm';
      case 'oga':
      case 'ogg':
        return 'audio/ogg';
      case 'aiff':
      case 'aif':
        return 'audio/aiff';
      case 'amr':
        return 'audio/amr';
      case 'mid':
      case 'midi':
        return 'audio/midi';
      case 'caf':
        return 'audio/x-caf';
      default:
        return '';
    }
  }

  private getFileExtension(file_name: string): string {
    return file_name.split('?')[0].split('.').pop()?.toLowerCase() ?? '';
  }

  private getBudgetableName(budgetable: WorkingTimeCategory | CompanyProductTeam): string {
    if ((budgetable as WorkingTimeCategory).short_name != null) return (budgetable as WorkingTimeCategory).short_name;
    else return budgetable.name;
  }

  private getProgressSpinnerClassListByBudget(budget: ProductTaskBoardTimeBudgetCustom | ProductTaskTimeBudgetCustom): any {
    if ((budget as ProductTaskBoardTimeBudgetCustom).product_task_board_id != null) {
      const b: ProductTaskBoardTimeBudgetCustom = budget as ProductTaskBoardTimeBudgetCustom;
      return {
        disabled: b.time_in_seconds == null || b.time_in_seconds <= 0,
        start:
          b.time_in_seconds != null &&
          b.time_in_seconds > 0 &&
          b.time_registered_in_seconds_for_client <= b.time_in_seconds &&
          b.completed_by_user_id == null &&
          b.time_registered_in_seconds_for_client == 0,
        inprogress:
          b.time_in_seconds != null &&
          b.time_in_seconds > 0 &&
          b.time_registered_in_seconds_for_client <= b.time_in_seconds &&
          b.completed_by_user_id == null &&
          b.time_registered_in_seconds_for_client > 0,
        finished:
          b.time_in_seconds != null &&
          b.time_in_seconds > 0 &&
          b.time_registered_in_seconds_for_client <= b.time_in_seconds &&
          b.completed_by_user_id != null,
        overtime: b.time_in_seconds != null && b.time_in_seconds > 0 && b.time_registered_in_seconds_for_client > b.time_in_seconds,
      };
    } else if ((budget as ProductTaskTimeBudgetCustom).product_task_id != null) {
      const b: ProductTaskTimeBudgetCustom = budget as ProductTaskTimeBudgetCustom;
      return {
        disabled: b.time_in_seconds == null || b.time_in_seconds <= 0,
        start:
          b.time_in_seconds != null &&
          b.time_in_seconds > 0 &&
          b.time_registered_in_seconds_for_client <= b.time_in_seconds &&
          b.completed_by_user_id == null &&
          b.time_registered_in_seconds_for_client == 0,
        inprogress:
          b.time_in_seconds != null &&
          b.time_in_seconds > 0 &&
          b.time_registered_in_seconds_for_client <= b.time_in_seconds &&
          b.completed_by_user_id == null &&
          b.time_registered_in_seconds_for_client > 0,
        finished:
          b.time_in_seconds != null &&
          b.time_in_seconds > 0 &&
          b.time_registered_in_seconds_for_client <= b.time_in_seconds &&
          b.completed_by_user_id != null,
        overtime: b.time_in_seconds != null && b.time_in_seconds > 0 && b.time_registered_in_seconds_for_client > b.time_in_seconds,
      };
    }
  }

  private getProgressSpinnerClassListGeneral(): any {
    return {
      disabled: this.task.ro_time_estimation <= 0,
      start:
        this.task.ro_time_estimation > 0 &&
        this.task.time_registered_in_seconds_for_client <= this.task.ro_time_estimation &&
        !this.task.is_completed &&
        this.task.time_registered_in_seconds_for_client == 0,
      inprogress:
        this.task.ro_time_estimation > 0 &&
        this.task.time_registered_in_seconds_for_client <= this.task.ro_time_estimation &&
        !this.task.is_completed &&
        this.task.time_registered_in_seconds_for_client > 0,
      finished:
        this.task.ro_time_estimation > 0 &&
        this.task.time_registered_in_seconds_for_client <= this.task.ro_time_estimation &&
        this.task.is_completed,
      overtime: this.task.ro_time_estimation > 0 && this.task.time_registered_in_seconds_for_client > this.task.ro_time_estimation,
    };
  }

  private getProgressSpinnerValueGeneral(): number {
    if (this.task.ro_time_estimation <= 0) return 100;
    else {
      const prcnt = this.task.time_registered_in_seconds_for_client / this.task.ro_time_estimation;
      if (prcnt > 1 || prcnt == 0) return 100;
      else return prcnt * 100;
    }
  }

  private getProgressSpinnerClassListSprint(): any {
    const currentBoard = this.product_task_board();
    if (!currentBoard) return {};
    return {
      disabled: currentBoard.ro_time_estimation <= 0,
      start:
        currentBoard.ro_time_estimation > 0 &&
        currentBoard.time_registered_in_seconds_for_client <= currentBoard.ro_time_estimation &&
        !currentBoard.is_completed &&
        currentBoard.time_registered_in_seconds_for_client == 0,
      inprogress:
        currentBoard.ro_time_estimation > 0 &&
        currentBoard.time_registered_in_seconds_for_client <= currentBoard.ro_time_estimation &&
        !currentBoard.is_completed &&
        currentBoard.time_registered_in_seconds_for_client > 0,
      finished:
        currentBoard.ro_time_estimation > 0 &&
        currentBoard.time_registered_in_seconds_for_client <= currentBoard.ro_time_estimation &&
        currentBoard.is_completed,
      overtime: currentBoard.ro_time_estimation > 0 && currentBoard.time_registered_in_seconds_for_client > currentBoard.ro_time_estimation,
    };
  }

  private getProgressSpinnerValueSprint(): number {
    const currentBoard = this.product_task_board();
    if (!currentBoard || currentBoard.ro_time_estimation <= 0) return 100;
    else {
      const prcnt = currentBoard.time_registered_in_seconds_for_client / currentBoard.ro_time_estimation;
      if (prcnt > 1 || prcnt == 0) return 100;
      else return prcnt * 100;
    }
  }

  private initPMorPO() {
    this.is_client = this.permissions.isClient();
    this.isClientBusiness = this.permissions.isClientBusiness();
    this.isProductionTeam = this.permissions.isProductionTeamInCompanyProduct(this.company_product_id.toString());
    this.canArchiveOrDelete =
      this.user_permissions().can_archive_or_delete_tasks ||
      (this.user_permissions().can_create_tasks_on_backlog && this.task.is_draft && this.task.creator_id === this.me.id);
  }

  private async fetchUserPermissions(): Promise<void> {
    await firstValueFrom(this.user_permissions_request$);
  }

  /**
   * Parents pass EMPTY_COMPANY_PRODUCT_PHASE_USER_PERMISSIONS as toSignal initialValue
   * before the API resolves. That object is truthy but not authoritative — on refresh
   * with ?selectedIssue= the dialog would otherwise lock as if the board were inactive.
   */
  private hasAuthoritativeUserPermissions(
    permissions: CompanyProductPhaseUserPermissions | undefined
  ): permissions is CompanyProductPhaseUserPermissions {
    return permissions != null && permissions !== EMPTY_COMPANY_PRODUCT_PHASE_USER_PERMISSIONS;
  }

  private async initCurrentBoardAttribute(): Promise<void> {
    const company_product_phase_board_id: number | string = this.data.company_product_phase_board_id;
    if (typeof company_product_phase_board_id === 'string') {
      return;
    }

    const from_dialog_board = this.data.current_board;
    if (
      from_dialog_board != null &&
      Number(from_dialog_board.id) === Number(company_product_phase_board_id) &&
      Array.isArray(from_dialog_board.company_product_phase_board_cols) &&
      from_dialog_board.company_product_phase_board_cols.length > 0
    ) {
      this.currentBoard = from_dialog_board;
      this.applyCurrentBoardInactiveFlag();

      return;
    }

    const data = await firstValueFrom(
      this.api
        .getCompanyProductPhaseBoard(company_product_phase_board_id, { with: 'company_product_phase_board_cols' })
        .pipe(takeUntilDestroyed(this.destroy_ref))
    );
    if (data) {
      this.currentBoard = data;
      this.applyCurrentBoardInactiveFlag();
    }
  }

  private applyCurrentBoardInactiveFlag(): void {
    if (!this.currentBoard) {
      return;
    }

    this.is_current_board_old_and_inactive =
      this.currentBoard.end_date !== undefined && this.currentBoard.end_date !== null && new Date(this.currentBoard.end_date) < new Date();
    this.is_current_board_future = this.utils.isCompanyProductPhaseBoardFuture(this.currentBoard);
  }

  private initProductTaskBoardAttribute() {
    const company_product_phase_board_id: number | string = this.data.company_product_phase_board_id;
    if (typeof company_product_phase_board_id !== 'string') {
      // busquem el task board dintre task
      for (const product_task_board of this.task.product_task_boards) {
        if (product_task_board.company_product_phase_board_col.company_product_phase_board_id == company_product_phase_board_id) {
          const boardWithTask = { ...product_task_board, product_task: this.task };
          this.product_task_board.set(boardWithTask);
          // es necessita en alguns mètodes compartits amb altres components
          this.initHasOtherReviewerAttribute(boardWithTask.product_task_board_time_budgets);
          this.initActiveTimeBudget();
          // console.log("this.product_task_board.product_task_board_time_budgets", boardWithTask.product_task_board_time_budgets)
          break;
        }
      }
    }
  }

  private checkInputData() {
    if (this.data == null) {
      this.snack.open('No se ha proporcionado los inputs necesarios. Cerrando popup...', 'Ok', { duration: 5000 });
      this.close();
    }
    if (this.data.task_code_id == null) {
      this.snack.open('No se ha proporcionado el parámetro task_id. Cerrando popup...', 'Ok', { duration: 5000 });
      this.close();
    }
    if (this.data.company_product_phase_board_id == null) {
      this.snack.open('No se ha proporcionado el parámetro company_product_phase_board_id. Cerrando popup...', 'Ok', { duration: 5000 });
      this.close();
    }
    if (this.data.company_product_id == null) {
      this.snack.open('No se ha proporcionado el parámetro company_product_id. Cerrando popup...', 'Ok', { duration: 5000 });
      this.close();
    }
  }

  private async onGetTaskData(data: ProductTask, loadMode: 'essential' | 'full'): Promise<void> {
    this.processHistoryLogs(data);
    this.task = data as ProductTaskCustom;
    this.task.product_task_requesters ??= [];
    this.task.attachments = this.serializeAttachments(this.task.attachments ?? []);
    this.task.comments = (this.task.comments ?? []).map(comment => this.commentToCommentCustom(comment));
    this.task.history_logs ??= [];
    this.task.product_task_design_links ??= [];
    this.hydrateCompanyProductEpicFromLocalEpicsIfNeeded();
    this.setTitleAndDescription();
    this.hydrateTagsFromTask();
    this.initPMorPO();
    await this.initCurrentBoardAttribute();
    if (loadMode === 'essential') {
      await this.ensureWorkingTimesFragmentLoaded();
    } else {
      this.processWorkingTimes();
    }
    this.processBudgets();
    this.initProductTaskBoardAttribute();
    this.initIsTaskColumnSelectorDisabledAttribute();
    this.fetchCompanyProductPhaseBacklogTimeAutocalcSettings();
    this.processCompanyProductUserMembers();
    this.isTaskLoaded = true;
    this.imFollowingTask = (this.task.product_task_listeners ?? []).find(u => u.id == this.me.id) !== undefined;
    this.imTaskRequester = (this.task.product_task_requesters ?? []).some(requester => requester.id === this.me.id);

    if (loadMode === 'full') {
      this.commentsFragmentFullyLoaded = true;
      this.commentsFragmentLoading = false;
      this.historyFragmentFullyLoaded = true;
      this.historyFragmentLoading = false;
      this.distributionFragmentFullyLoaded = true;
      this.distributionFragmentLoading = false;
      this.workingTimesFragmentFullyLoaded = true;
      this.workingTimesFragmentLoading = false;
      await this.initDistributionTable();
    }

    this.initSpinnerData();
    this.ui_product_task_origin_category_id = data.product_task_origin_category_id;
    if (!this.product_task_origin_category_snapshot_initialized) {
      this.initial_snapshot_product_task_origin_category_id = data.product_task_origin_category_id;
      this.product_task_origin_category_snapshot_initialized = true;
    }
    this.refreshFilteredOriginCategories();
    this.maybeFetchProductTaskOriginCategories();

    if (loadMode === 'essential') {
      this.loadCommentsFragment();
    }
  }

  private hydrateCompanyProductEpicFromLocalEpicsIfNeeded(): void {
    if (this.task.company_product_epic_id == null) {
      return;
    }
    if (this.task.company_product_epic?.name) {
      return;
    }
    const epic = this.company_product_epics?.find((e: CompanyProductEpic): boolean => e.id === this.task.company_product_epic_id);
    if (epic) {
      this.task.company_product_epic = epic as ProductTask['company_product_epic'];
    }
  }

  private maybeFetchProductTaskOriginCategories(): void {
    if (this.productTaskOriginCategoriesFetchStarted) {
      return;
    }
    if (!this.shouldFetchProductTaskOriginCategories()) {
      return;
    }
    this.productTaskOriginCategoriesFetchStarted = true;
    this.fetchProductTaskOriginCategories();
  }

  private shouldFetchProductTaskOriginCategories(): boolean {
    if (!this.task || !this.company_product_phase) {
      return false;
    }
    if (this.task.is_completed || this.is_current_board_old_and_inactive || !this.user_permissions().can_edit_backlog) {
      return false;
    }

    return this.initial_snapshot_product_task_origin_category_id === null;
  }

  private hydrateTagsFromTask(): void {
    const task_tags = this.task?.tags ?? [];
    this.tags = task_tags.map((product_task_tag: { tag: { title: string } }) => product_task_tag.tag.title);
    this.tag_categories = task_tags
      .map((product_task_tag: { tag: ProductTaskTagCategory }) => product_task_tag.tag)
      .filter(
        (tag_category: ProductTaskTagCategory, index: number, categories: ProductTaskTagCategory[]) =>
          categories.findIndex((category: ProductTaskTagCategory) => category.id === tag_category.id) === index
      );
  }

  private mergeTagCategories(categories: ProductTaskTagCategory[]): void {
    for (const category of categories) {
      const already_exists = this.tag_categories.some((tag_category: ProductTaskTagCategory) => tag_category.id === category.id);
      if (!already_exists) {
        this.tag_categories.push(category);
      }
    }
  }

  private isTagAlreadyOnTask(title: string): boolean {
    const normalized_title = title.toLowerCase();

    return this.tags.some((tag: string) => tag.toLowerCase() === normalized_title);
  }

  private findTagCategoryByTitle(title: string): ProductTaskTagCategory | undefined {
    const normalized_title = title.toLowerCase();

    return this.tag_categories.find((tag_category: ProductTaskTagCategory) => tag_category.title.toLowerCase() === normalized_title);
  }

  private attachTagCategoryToTask(tag_category: ProductTaskTagCategory): void {
    if (this.isTagAlreadyOnTask(tag_category.title)) {
      return;
    }

    const product_task_tag = {
      task_id: this.task.id,
      tag_id: tag_category.id,
    };

    this.api
      .createTaskTag(product_task_tag)
      .pipe(takeUntilDestroyed(this.destroy_ref))
      .subscribe(task_tag => {
        this.tags.push(tag_category.title);
        this.task.tags.push(task_tag);
      });
  }

  private resolveTagCategoryAndAttach(title: string): void {
    this.api
      .getTaskTagCategories({
        search: title,
        per_page: 20,
        select: 'id|title',
      })
      .pipe(
        switchMap((response: ProductTaskTagCategory[] | ArrayResponse<ProductTaskTagCategory>) => {
          const categories = Array.isArray(response) ? response : response.data;
          const existing_tag_category = categories.find(
            (tag_category: ProductTaskTagCategory) => tag_category.title.toLowerCase() === title.toLowerCase()
          );

          if (existing_tag_category) {
            this.mergeTagCategories([existing_tag_category]);
            return of(existing_tag_category);
          }

          return this.api
            .createTaskTagCategory({ title })
            .pipe(tap((tag_category: ProductTaskTagCategory) => this.mergeTagCategories([tag_category])));
        }),
        takeUntilDestroyed(this.destroy_ref)
      )
      .subscribe((tag_category: ProductTaskTagCategory) => {
        this.attachTagCategoryToTask(tag_category);
      });
  }

  private initIsTaskColumnSelectorDisabledAttribute() {
    const currentBoard = this.product_task_board();
    if (this.currentBoard != null && currentBoard != null && this.company_product_phase != null) {
      const column: CompanyProductPhaseBoardCol | undefined = this.currentBoard.company_product_phase_board_cols?.find(
        c => c.id === currentBoard?.company_product_phase_board_col_id
      );
      if (column) {
        this.is_task_column_selector_disabled = CompanyProductPhaseBoardDetailComponent.isProductTaskBoardDragDisabled(
          currentBoard,
          column,
          this.me,
          this.company_product_phase,
          this.currentBoard,
          this.user_permissions().can_drag_in_board,
          this.user_permissions().can_edit_board
        );
      } else this.is_task_column_selector_disabled = true;
    } else this.is_task_column_selector_disabled = true;
  }

  private processWorkingTimes() {
    this.mergeWorkingTimesIntoTaskBudgetsFromServer();

    // inicialitzem
    this.task.time_registered_in_seconds_for_client = 0;
    this.task.time_registered_in_seconds_real = 0;
    this.task.ro_working_times = [];
    for (const budget of this.task.product_task_time_budgets) {
      budget.time_registered_in_seconds_for_client = 0;
      budget.time_registered_in_seconds_real = 0;
    }

    // processem
    for (const product_task_board of this.task.product_task_boards) {
      product_task_board.time_registered_in_seconds_for_client = 0;
      product_task_board.time_registered_in_seconds_real = 0;

      for (const budget of product_task_board.product_task_board_time_budgets) {
        budget.time_registered_in_seconds_for_client = 0;
        budget.time_registered_in_seconds_real = 0;

        const general_budget: ProductTaskTimeBudgetCustom | undefined = this.task.product_task_time_budgets.find(
          b => b.budgetable_id === budget.budgetable_id && b.budgetable_type === budget.budgetable_type
        );

        (budget.working_times ?? []).forEach(wt => {
          budget.time_registered_in_seconds_for_client += wt.duration_in_seconds_for_client;
          budget.time_registered_in_seconds_real += wt.duration_in_seconds_real;

          product_task_board.time_registered_in_seconds_for_client += wt.duration_in_seconds_for_client;
          product_task_board.time_registered_in_seconds_real += wt.duration_in_seconds_real;

          this.task.time_registered_in_seconds_for_client += wt.duration_in_seconds_for_client;
          this.task.time_registered_in_seconds_real += wt.duration_in_seconds_real;

          if (general_budget != null) {
            general_budget.time_registered_in_seconds_for_client += wt.duration_in_seconds_for_client;
            general_budget.time_registered_in_seconds_real += wt.duration_in_seconds_real;

            if (general_budget.completed_by_user_id == null && budget.completed_by_user_id != null)
              general_budget.completed_by_user_id = budget.completed_by_user_id;
          }

          this.task.ro_working_times.push(this.enrichWorklogForActivityDisplay(wt));
        });
      }
    }

    this.task.ro_working_times.sort((a, b) => dayjs(b.created_at).diff(dayjs(a.created_at)));
  }

  private enrichWorklogForActivityDisplay(worklog: WorkingTime): WorkingTimeActivityEntry {
    return {
      ...worklog,
      activity_category_display: this.buildActivityCategoryDisplay(worklog),
      can_edit_or_delete: worklog.user_id === this.me.id && this.canEditOrDeleteWorkingTime(worklog),
    };
  }

  private buildActivityCategoryDisplay(worklog: WorkingTime): string {
    const category_name = worklog.working_time_category?.name ?? 'Trabajo';

    if (worklog.working_time_category?.slug !== 'review-task') {
      return category_name;
    }

    const review_target_label = this.getReviewTargetLabelForWorklog(worklog);

    if (review_target_label == null) {
      return category_name;
    }

    return `${category_name} (${review_target_label})`;
  }

  private getReviewTargetLabelForWorklog(worklog: WorkingTime): string | null {
    const target_slug = this.resolveReviewTargetBudgetSlug(worklog);

    if (target_slug === 'product-design') {
      return 'UX/UI';
    }

    if (target_slug === 'task-time-tracking') {
      return 'DEV';
    }

    return null;
  }

  private resolveReviewTargetBudgetSlug(worklog: WorkingTime): string | null {
    const relatable = worklog.relatable as ProductTaskBoardTimeBudget | null | undefined;

    if (relatable != null && relatable.budgetable_type === 'App\\Models\\WorkingTimeCategory' && relatable.budgetable != null) {
      return (relatable.budgetable as WorkingTimeCategory).slug ?? null;
    }

    if (worklog.relatable_id == null) {
      return null;
    }

    for (const board of this.task.product_task_boards ?? []) {
      const target_budget = board.product_task_board_time_budgets.find(
        (budget: ProductTaskBoardTimeBudgetCustom): boolean => budget.id === worklog.relatable_id
      );

      if (
        target_budget == null ||
        target_budget.budgetable_type !== 'App\\Models\\WorkingTimeCategory' ||
        target_budget.budgetable == null
      ) {
        continue;
      }

      return (target_budget.budgetable as WorkingTimeCategory).slug ?? null;
    }

    return null;
  }

  private collectAllWorkingTimesFromTaskBudgets(): WorkingTime[] {
    const by_id = new Map<number, WorkingTime>();

    for (const product_task_board of this.task.product_task_boards ?? []) {
      for (const budget of product_task_board.product_task_board_time_budgets ?? []) {
        for (const working_time of budget.working_times ?? []) {
          if (!by_id.has(working_time.id)) {
            by_id.set(working_time.id, working_time);
          }
        }
      }
    }

    return Array.from(by_id.values());
  }

  private mergeWorkingTimesIntoTaskBudgetsFromServer(working_times?: WorkingTime[]): void {
    const working_times_to_merge = working_times ?? this.collectAllWorkingTimesFromTaskBudgets();
    const budget_relatable_type: WorkingTime['relatable_type'] = 'App\\Models\\ProductTaskBoardTimeBudget';
    for (const board of this.task.product_task_boards ?? []) {
      for (const budget of board.product_task_board_time_budgets ?? []) {
        if (budget.id != null && budget.id !== 0) {
          budget.working_times = [];
        }
      }
    }
    const by_budget_id = new Map<number, WorkingTime[]>();
    for (const wt of working_times_to_merge) {
      if (wt.relatable_type !== budget_relatable_type) {
        continue;
      }

      const is_review_task = wt.working_time_category?.slug === 'review-task';
      const budget_id = is_review_task ? wt.review_task_product_task_board_time_budget_id : wt.relatable_id;

      if (budget_id == null) {
        continue;
      }

      const list = by_budget_id.get(budget_id) ?? [];
      list.push(wt);
      by_budget_id.set(budget_id, list);
    }
    for (const board of this.task.product_task_boards ?? []) {
      for (const budget of board.product_task_board_time_budgets ?? []) {
        if (budget.id != null && budget.id !== 0) {
          const list = by_budget_id.get(budget.id);
          if (list != null && list.length > 0) {
            list.sort((a, b) => dayjs(b.created_at).diff(dayjs(a.created_at)));
            budget.working_times = list;
          } else if (!budget.working_times) {
            budget.working_times = [];
          }
        }
      }
    }
  }

  private applyHistoryLogsFromApi(logs: ProductTaskHistoryLog[]): void {
    this.historyLogs = [...logs].sort((a, b) => {
      const dateA = new Date(a.created_at).getTime();
      const dateB = new Date(b.created_at).getTime();
      return dateB - dateA;
    });
  }

  private processHistoryLogs(task: ProductTask) {
    const taskLogs = task.history_logs || [];
    const budgetsLogs = (task.product_task_boards || [])
      .flatMap(board => board.product_task_board_time_budgets || [])
      .flatMap(budget => budget.history_logs || []);

    const allLogs = [...taskLogs, ...budgetsLogs];

    this.historyLogs = allLogs.sort((a, b) => {
      const dateA = new Date(a.created_at).getTime();
      const dateB = new Date(b.created_at).getTime();
      return dateB - dateA;
    });
  }

  private processBudgets() {
    for (const board of this.task.product_task_boards) {
      board.is_completed = true;
      for (const budget of board.product_task_board_time_budgets) {
        budget.product_task_time_budget = this.task.product_task_time_budgets.find(
          b => b.budgetable_type === budget.budgetable_type && b.budgetable_id === budget.budgetable_id
        );

        board.is_completed = board.is_completed && budget.completed_by_user_id != null;
      }
    }
  }

  private async initDistributionTable() {
    this.distribution_table = {} as ProductTaskDistribution;
    const budget_categories: ProductTaskTimeBudgetCustom[] = this.task.product_task_time_budgets;

    // general
    const general_categories = budget_categories.map(time_budget => {
      return {
        title: this.getBudgetableName(time_budget.budgetable),
        time_to_do: time_budget.time_in_seconds,
        time_done: time_budget.time_registered_in_seconds_for_client,
        completed: time_budget.completed_by_user_id != null,
        editable: true,
        budgetable_type: time_budget.budgetable_type as 'App\\Models\\WorkingTimeCategory' | 'App\\Models\\CompanyProductTeam' | undefined,
        budgetable_id: time_budget.budgetable_id as number | undefined,
        budgetable_slug:
          (time_budget.budgetable as WorkingTimeCategory).slug != null ? (time_budget.budgetable as WorkingTimeCategory).slug : undefined,
      };
    });
    general_categories.unshift({
      title: 'General',
      time_to_do: this.task.ro_time_estimation,
      time_done: this.task.time_registered_in_seconds_for_client,
      completed: this.task.is_completed,
      editable: false,
      budgetable_type: undefined,
      budgetable_id: undefined,
      budgetable_slug: undefined,
    });
    this.distribution_table.general = {
      title: 'General',
      from: undefined,
      to: undefined,
      bold_title: true,
      categories: general_categories,
      company_product_phase_board_id: null,
      status: null,
    };

    // asignado
    const asignado_categories = budget_categories.map(time_budget => {
      return {
        title: this.getBudgetableName(time_budget.budgetable),
        time_to_do: 0, // numero d'hores que s'ha de fer per cada categoria als sprints o al llarg dels sprints (Time Budget)
        time_done: 0, // numero d'hores assignades per cada categoria al llarg dels sprints (sumatori)
        completed: false,
        editable: false,
        budgetable_type: time_budget.budgetable_type as 'App\\Models\\WorkingTimeCategory' | 'App\\Models\\CompanyProductTeam' | undefined,
        budgetable_id: time_budget.budgetable_id as number | undefined,
        budgetable_slug:
          (time_budget.budgetable as WorkingTimeCategory).slug != null ? (time_budget.budgetable as WorkingTimeCategory).slug : undefined,
      };
    });
    asignado_categories.unshift({
      title: 'General',
      time_to_do: 0,
      time_done: 0,
      completed: false,
      editable: false,
      budgetable_type: undefined,
      budgetable_id: undefined,
      budgetable_slug: undefined,
    });
    this.distribution_table.assigned = {
      title: 'Asignado',
      from: undefined,
      to: undefined,
      bold_title: true,
      categories: asignado_categories,
      company_product_phase_board_id: null,
      status: null,
    };

    // sprints
    this.distribution_table.boards = [];
    const boards = this.task.company_product_phase.company_product_phase_boards;
    const currentBoard = this.product_task_board();
    if (currentBoard != null && currentBoard.company_product_phase_board_col != null) {
      const found = boards.find(board => board.id == currentBoard.company_product_phase_board_col?.company_product_phase_board_id);
      if (!found) {
        const board = await firstValueFrom(
          this.api
            .getCompanyProductPhaseBoard(currentBoard.company_product_phase_board_col.company_product_phase_board_id)
            .pipe(takeUntilDestroyed(this.destroy_ref))
        );
        if (board) {
          boards.push(board);
        }
      }
    }

    boards.sort((a, b) => {
      if (a.start_date == undefined) return 0;
      else if (b.start_date == undefined) return 1;
      else return a.start_date < b.start_date ? 1 : 0;
    });

    boards.forEach(board => {
      const product_task_board: ProductTaskBoardCustom | undefined = this.task.product_task_boards.find(
        b => b.company_product_phase_board_col.company_product_phase_board_id == board.id
      );
      const categories = budget_categories.map(time_budget => {
        const product_task_board_time_budget: ProductTaskBoardTimeBudgetCustom | undefined =
          product_task_board != null
            ? product_task_board.product_task_board_time_budgets.find(
                ptbtb => ptbtb.budgetable_type === time_budget.budgetable_type && ptbtb.budgetable_id === time_budget.budgetable_id
              )
            : undefined;
        return {
          title: this.getBudgetableName(time_budget.budgetable),
          time_to_do:
            product_task_board_time_budget != null && product_task_board_time_budget.time_in_seconds != null
              ? product_task_board_time_budget.time_in_seconds
              : 0,
          time_done: product_task_board_time_budget != null ? product_task_board_time_budget.time_registered_in_seconds_for_client : 0,
          completed: product_task_board_time_budget != null && product_task_board_time_budget.completed_by_user_id != null,
          editable: true,
          budgetable_type: time_budget.budgetable_type as
            | 'App\\Models\\WorkingTimeCategory'
            | 'App\\Models\\CompanyProductTeam'
            | undefined,
          budgetable_id: time_budget.budgetable_id as number | undefined,
          budgetable_slug:
            (time_budget.budgetable as WorkingTimeCategory).slug != null ? (time_budget.budgetable as WorkingTimeCategory).slug : undefined,
        };
      });
      categories.unshift({
        title: 'General',
        time_to_do: product_task_board?.ro_time_estimation ?? 0,
        time_done: product_task_board?.time_registered_in_seconds_for_client ?? 0,
        completed: product_task_board != null && product_task_board.completed_by_user_id != null,
        editable: false,
        budgetable_type: undefined,
        budgetable_id: undefined,
        budgetable_slug: undefined,
      });
      this.distribution_table.boards.push({
        title: board.title ?? 'Tablero #' + board.id,
        from: board.start_date,
        to: board.end_date,
        bold_title: false,
        categories: categories,
        company_product_phase_board_id: board.id,
        status: board.status,
      });
    });
  }

  private getGeneralTaskSpinnerData(): SpinnerData {
    return {
      tooltip:
        'Se han registrado un total de ' +
        this.secondsToStringTime.transform(this.task.time_registered_in_seconds_for_client) +
        ' de ' +
        this.secondsToStringTime.transform(this.task.ro_time_estimation) +
        ' estimadas para el total de la tarea.',
      class: this.getProgressSpinnerClassListGeneral(),
      value: this.getProgressSpinnerValueGeneral(),
      text:
        this.decimal.transform(this.task.time_registered_in_seconds_for_client / 3600, '1.0-0') +
        '/' +
        this.decimal.transform(this.task.ro_time_estimation / 3600, '1.0-0'),
      can_register: false,
    };
  }

  private getGeneralCategorySpinnerData(time_budget: ProductTaskTimeBudgetCustom): SpinnerData {
    return {
      tooltip:
        'Se han registrado en ' +
        this.getBudgetableName(time_budget.budgetable) +
        ' ' +
        this.secondsToStringTime.transform(time_budget.time_registered_in_seconds_for_client) +
        ' ' +
        (time_budget.time_in_seconds > 0
          ? ' de ' + this.secondsToStringTime.transform(time_budget.time_in_seconds) + ' estimadas para el total de la tarea.'
          : '.'),
      class: this.getProgressSpinnerClassListByBudget(time_budget),
      value: this.getProgressSpinnerValueByBudget(time_budget),
      text:
        this.decimal.transform(time_budget.time_registered_in_seconds_for_client / 3600, '1.0-0') +
        '/' +
        this.decimal.transform(time_budget.time_in_seconds != null ? time_budget.time_in_seconds / 3600 : 0, '1.0-0'),
      can_register: false,
    };
  }

  private initSpinnerData() {
    this.estimation_template_data = undefined;

    const currentBoard = this.product_task_board();
    if (currentBoard != null) {
      const general_row: SpinnerGroupData = {
        title: 'General',
        product_task_board_time_budget: undefined,
        product_task_time_budget: undefined,
        should_show_completed_category_icon: false,
        completed_tooltip: '',
        idx: undefined,
        assignee: undefined,
        show_assignee: false,
        available_assignees: [],
        can_choose_assignee: false,
        is_assigned_to_me: false,
        is_active_budget: false,
        can_register: false,
        show_delete_time_budget: false,
        spinners: [
          {
            tooltip:
              'Se han registrado en total de ' +
              this.secondsToStringTime.transform(currentBoard.time_registered_in_seconds_for_client) +
              ' de ' +
              this.secondsToStringTime.transform(currentBoard.ro_time_estimation) +
              ' estimadas para este tablero.',
            class: this.getProgressSpinnerClassListSprint(),
            value: this.getProgressSpinnerValueSprint(),
            text:
              this.decimal.transform(currentBoard.time_registered_in_seconds_for_client / 3600, '1.0-0') +
              '/' +
              this.decimal.transform(currentBoard.ro_time_estimation / 3600, '1.0-0'),
            can_register:
              !this.task.is_completed &&
              (this.isProductionTeam || this.user_permissions().can_edit_board) &&
              !this.is_current_board_old_and_inactive,
          },
          this.getGeneralTaskSpinnerData(),
        ],
      };

      const budgets_to_display = [...currentBoard.product_task_board_time_budgets];

      const hasAnyVirtualBudgetEnabled = this.virtualBudgets().some((vb: VirtualBudgetConfig): boolean => vb.isEnabled);

      if (hasAnyVirtualBudgetEnabled && this.user_permissions().can_edit_board) {
        ['product-design', 'review-task', 'task-time-tracking'].forEach((slug: string): void => {
          this.addVirtualBudgetIfNeeded(slug, budgets_to_display);
        });
      }

      budgets_to_display.sort((a: ProductTaskBoardTimeBudgetCustom, b: ProductTaskBoardTimeBudgetCustom): number => {
        const getBudgetOrder = (budget: ProductTaskBoardTimeBudgetCustom): number => {
          if (budget.budgetable_type === 'App\\Models\\WorkingTimeCategory' && budget.budgetable) {
            const slug = (budget.budgetable as WorkingTimeCategory)?.slug;
            if (slug) {
              switch (slug) {
                case 'task-time-tracking':
                  return 1;
                case 'review-task':
                  return 2;
                case 'product-design':
                  return 3;
                default:
                  return 4;
              }
            }
          }

          return 5;
        };

        return getBudgetOrder(a) - getBudgetOrder(b);
      });

      const category_rows = budgets_to_display.map((time_budget, idx): SpinnerGroupData => {
        if (time_budget.product_task_time_budget === undefined) {
          time_budget.product_task_time_budget = this.task.product_task_time_budgets.find((b: ProductTaskTimeBudgetCustom): boolean => {
            return b.budgetable_type === time_budget.budgetable_type && b.budgetable_id === time_budget.budgetable_id;
          });
        }

        const can_register: boolean =
          !this.task.is_completed &&
          !this.is_current_board_old_and_inactive &&
          ((time_budget.budgetable_type === 'App\\Models\\CompanyProductTeam' &&
            this.permissions.isInCompanyProductTeam(time_budget.budgetable_id)) || // o la categoria és review time
            (time_budget.budgetable_type === 'App\\Models\\WorkingTimeCategory' &&
              (time_budget.budgetable as WorkingTimeCategory).slug === 'review-task' &&
              this.permissions.isProductionTeamInCompanyProduct(this.company_product_id.toString()) &&
              this.permissions.isWorker()) || // sóc desenvolupador de Bisual amb permissos per registrar
            (time_budget.budgetable_type === 'App\\Models\\WorkingTimeCategory' &&
              this.permissions.isBisualProductionTeamInCompanyProduct(this.company_product_id.toString())));

        const spinners: SpinnerData[] = [];

        // afegim el de sprint
        spinners.push({
          tooltip:
            'Se han registrado en ' +
            this.getBudgetableName(time_budget.budgetable) +
            ' ' +
            this.secondsToStringTime.transform(time_budget.time_registered_in_seconds_for_client) +
            ' ' +
            (time_budget.time_in_seconds != null
              ? ' de ' + this.secondsToStringTime.transform(time_budget.time_in_seconds) + ' estimadas para este tablero.'
              : '.'),
          class: this.getProgressSpinnerClassListByBudget(time_budget),
          value: this.getProgressSpinnerValueByBudget(time_budget),
          text:
            this.decimal.transform(time_budget.time_registered_in_seconds_for_client / 3600, '1.0-0') +
            '/' +
            this.decimal.transform(time_budget.time_in_seconds != null ? time_budget.time_in_seconds / 3600 : 0, '1.0-0'),
          can_register: can_register,
        });

        // afegim el de general
        if (time_budget.product_task_time_budget != null) {
          spinners.push(this.getGeneralCategorySpinnerData(time_budget.product_task_time_budget));
        }

        const show_delete_time_budget: boolean =
          time_budget.id !== 0 &&
          this.user_permissions().can_edit_board &&
          ((time_budget.budgetable as WorkingTimeCategory).is_working_time == null ||
            (time_budget.budgetable as WorkingTimeCategory).slug !== 'review-task') &&
          time_budget.assignee == null &&
          (time_budget.time_in_seconds == null || time_budget.time_in_seconds == 0) &&
          time_budget.time_registered_in_seconds_for_client == 0;

        const should_show_completed_category_icon =
          time_budget.completed_by_user_id != null ||
          (!this.isReviewTaskBudget(time_budget) && this.isCategoryCompletedInAnyBoard(time_budget));
        const can_choose_assignee = this.canChooseAssigneeForBudget();
        const is_assigned_to_me = time_budget.assignee_id != null && Number(time_budget.assignee_id) === Number(this.me.id);
        const is_active_budget =
          currentBoard.active_product_task_board_time_budget_id != null &&
          Number(time_budget.id) === Number(currentBoard.active_product_task_board_time_budget_id);

        let available_assignees = this.production_team_users.filter(user => {
          if (time_budget.budgetable_type === 'App\\Models\\WorkingTimeCategory') {
            if ((time_budget.budgetable as WorkingTimeCategory).slug === 'review-task') return true;
            else if ((time_budget.budgetable as WorkingTimeCategory).slug === 'task-time-tracking') {
              return (
                user.company_product_user_member &&
                (user.company_product_user_member.company_product_user_member_role.slug === 'developer' ||
                  user.company_product_user_member.company_product_user_member_role.slug === 'tech-lead' ||
                  user.company_product_user_member.company_product_user_member_role.slug === 'product-manager')
              );
            } else if ((time_budget.budgetable as WorkingTimeCategory).slug === 'product-design') {
              return (
                user.company_product_user_member &&
                (user.company_product_user_member.company_product_user_member_role.slug === 'product-designer' ||
                  user.company_product_user_member.company_product_user_member_role.slug === 'product-manager')
              );
            } else {
              // potser fer un possible filtre per mapejar rols i categories...
              return user.role.slug === 'worker' || user.role.slug === 'partner';
            }
          } else {
            const team: CompanyProductTeam | undefined = this.company_product_teams[time_budget.budgetable_id];
            if (team) {
              return team.users.find(team_user => team_user.id === user.id);
            } else return false;
          }
        });

        // Prefer production-team hydrated user (has CPUM/role), fall back to API assignee relation.
        const resolved_assignee: UserCompanyProduct | undefined =
          time_budget.assignee_id != null
            ? (this.production_team_users.find((u: UserCompanyProduct): boolean => Number(u.id) === Number(time_budget.assignee_id)) ??
              (time_budget.assignee as UserCompanyProduct | undefined) ??
              undefined)
            : undefined;

        if (resolved_assignee != null) {
          time_budget.assignee = resolved_assignee;
          time_budget.assignee_id = Number(resolved_assignee.id);
        }

        // Without assign-others permission, only allow claiming yourself — but keep the
        // current assignee in the options so the select can bind and show their photo.
        if (!can_choose_assignee) {
          const self_option = available_assignees.find((user: UserCompanyProduct): boolean => Number(user.id) === Number(this.me.id));
          available_assignees = self_option != null ? [self_option] : [this.me];

          if (
            resolved_assignee != null &&
            Number(resolved_assignee.id) !== Number(this.me.id) &&
            !available_assignees.some((user: UserCompanyProduct): boolean => Number(user.id) === Number(resolved_assignee.id))
          ) {
            available_assignees = [...available_assignees, resolved_assignee];
          }
        }

        return {
          title: this.getBudgetableName(time_budget.budgetable),
          product_task_board_time_budget: time_budget,
          product_task_time_budget: undefined,
          should_show_completed_category_icon,
          completed_tooltip: this.buildCompletedCategoryTooltip(time_budget),
          idx: idx,
          assignee: resolved_assignee,
          show_assignee: true,
          available_assignees,
          can_choose_assignee,
          is_assigned_to_me,
          is_active_budget,
          can_register: can_register,
          show_delete_time_budget: show_delete_time_budget,
          spinners: spinners,
        };
      });

      this.estimation_template_data = [general_row, ...category_rows];
    } else {
      const general_row: SpinnerGroupData = {
        title: 'General',
        product_task_board_time_budget: undefined,
        product_task_time_budget: undefined,
        should_show_completed_category_icon: false,
        completed_tooltip: '',
        idx: undefined,
        assignee: undefined,
        show_assignee: false,
        available_assignees: [],
        can_choose_assignee: false,
        is_assigned_to_me: false,
        is_active_budget: false,
        can_register: false,
        show_delete_time_budget: false,
        spinners: [this.getGeneralTaskSpinnerData()],
      };

      const category_rows = this.task.product_task_time_budgets.map((time_budget, idx): SpinnerGroupData => {
        return {
          title: this.getBudgetableName(time_budget.budgetable),
          product_task_board_time_budget: undefined,
          product_task_time_budget: time_budget,
          should_show_completed_category_icon: time_budget.completed_by_user_id != null,
          completed_tooltip: time_budget.completed_by_user_id != null ? 'Categoría completada' : '',
          idx: idx,
          assignee: undefined,
          show_assignee: false,
          available_assignees: [],
          can_choose_assignee: false,
          is_assigned_to_me: false,
          is_active_budget: false,
          can_register: false,
          show_delete_time_budget: false,
          spinners: [this.getGeneralCategorySpinnerData(time_budget)],
        };
      });

      this.estimation_template_data = [general_row, ...category_rows];
    }
  }

  private processCompanyProductUserMembers() {
    const currentBoard = this.product_task_board();
    if (currentBoard != null) {
      currentBoard.product_task_board_time_budgets.forEach((time_budget: ProductTaskBoardTimeBudgetCustom) => {
        if (time_budget.assignee != null) {
          const user = this.production_team_users.find(up => up.id == time_budget.assignee_id);
          if (user) {
            time_budget.assignee.company_product_user_member = user.company_product_user_member;
          }
        }
      });
    }
  }

  private fetchProductTaskOriginCategories(): void {
    this.api
      .getProductTaskOriginCategories()
      .pipe(takeUntilDestroyed(this.destroy_ref))
      .subscribe((data: ArrayResponse<ProductTaskOriginCategory>): void => {
        this.product_task_origin_categories = data.data;
        this.refreshFilteredOriginCategories();
      });
  }

  private refreshFilteredOriginCategories(): void {
    if (!this.task) {
      this.filtered_origin_categories = [];
      return;
    }

    const task_type = this.task.type as ProductTaskOriginCategoryTypeAvailableEnum;

    this.filtered_origin_categories = this.product_task_origin_categories.filter(
      (product_task_origin_category: ProductTaskOriginCategory): boolean => {
        return product_task_origin_category.types_available?.includes(task_type) ?? false;
      }
    );
  }

  private fetchCompanyProductTeamsIfNeeded(): Promise<void> {
    if (this.data.company_product_teams != null) {
      this.applyCompanyProductTeamsFromDialogData(this.data.company_product_teams);

      return Promise.resolve();
    }

    return firstValueFrom(
      this.api.getCompanyProductCompanyProductTeams(this.company_product_id.toString(), { with: 'users' }).pipe(
        takeUntilDestroyed(this.destroy_ref),
        tap((teams: CompanyProductTeam[]) => {
          this.applyCompanyProductTeamsFromDialogData(teams);
        })
      )
    ).then(() => undefined);
  }

  private applyCompanyProductTeamsFromDialogData(teams: CompanyProductTeam[] | Record<number, CompanyProductTeam>): void {
    this.company_product_teams = {};
    if (Array.isArray(teams)) {
      teams.forEach((team: CompanyProductTeam) => {
        this.company_product_teams[team.id] = team;
      });

      return;
    }

    Object.assign(this.company_product_teams, teams);
  }

  private initHasOtherReviewerAttribute(time_budgets: ProductTaskBoardTimeBudgetCustom[]) {
    this.has_other_reviewer = time_budgets.some(
      budget =>
        budget.assignee &&
        budget.budgetable &&
        (budget.budgetable as WorkingTimeCategory).slug === 'review-task' &&
        budget.assignee_id !== this.me.id
    );
  }

  private fetchCompanyProductPhaseBacklogTimeAutocalcSettings(): void {
    const from_dialog = this.data.company_product_phase_task_time_autocalc_settings;
    if (from_dialog != null && from_dialog.length > 0) {
      this.company_product_phase_task_time_autocalc_settings = from_dialog.map((item: CompanyProductPhaseTaskTimeAutocalcSetting) => {
        const icon =
          (item as CompanyProductPhaseTaskTimeAutocalcSettingCustom).icon ??
          item.company_product_phase_task_time_autocalc_setting_category.working_time_category?.google_fonts_icon_slug ??
          'help';

        return {
          ...item,
          icon,
        };
      }) as CompanyProductPhaseTaskTimeAutocalcSettingCustom[];
      this.filterNotUsedCompanyProductPhaseBacklogTimeAutocalcSettings();
      if (this.product_task_board() != null) {
        this.initSpinnerData();
      }

      return;
    }

    this.api
      .getCompanyProductPhaseTaskTimeAutocalcSettings({ company_product_phase_id: this.company_product_phase_id })
      .pipe(takeUntilDestroyed(this.destroy_ref))
      .subscribe(data => {
        this.company_product_phase_task_time_autocalc_settings = data.data.map((item: CompanyProductPhaseTaskTimeAutocalcSetting) => {
          return {
            ...item,
            icon: item.company_product_phase_task_time_autocalc_setting_category.working_time_category?.google_fonts_icon_slug || 'help',
          };
        });
        this.filterNotUsedCompanyProductPhaseBacklogTimeAutocalcSettings();

        if (this.product_task_board() != null) {
          this.initSpinnerData();
        }
      });
  }

  private filterNotUsedCompanyProductPhaseBacklogTimeAutocalcSettings() {
    this.not_used_company_product_phase_task_time_autocalc_settings = this.company_product_phase_task_time_autocalc_settings.filter(
      (item: CompanyProductPhaseTaskTimeAutocalcSetting) => {
        const is_working_time_category: boolean = item.company_product_phase_task_time_autocalc_setting_category.working_time_category
          ?.is_working_time as boolean;
        // lets check if this task has a working time category with this working time category id
        if (!is_working_time_category) return false;
        else {
          const currentBoard = this.product_task_board();
          if (currentBoard != null) {
            return (
              currentBoard.product_task_board_time_budgets.filter(budget => {
                return (
                  budget.budgetable_type === 'App\\Models\\WorkingTimeCategory' &&
                  budget.budgetable_id == item.company_product_phase_task_time_autocalc_setting_category.working_time_category?.id
                );
              }).length == 0
            );
          } else {
            return (
              this.task?.product_task_time_budgets.filter(budget => {
                return (
                  budget.budgetable_type === 'App\\Models\\WorkingTimeCategory' &&
                  budget.budgetable_id == item.company_product_phase_task_time_autocalc_setting_category.working_time_category?.id
                );
              }).length == 0
            );
          }
        }
      }
    );
  }

  private async fetchCompanyProductPhaseAndEpicsIfNeeded(): Promise<void> {
    if (this.data.company_product_phase != null) {
      this.company_product_phase = this.data.company_product_phase;
      this.company_product_epics =
        this.data.company_product_epics ?? this.data.company_product_phase.company_product_epics ?? ([] as CompanyProductEpic[]);

      return;
    }

    this.company_product_phase = await firstValueFrom(
      this.api.getCompanyProductPhase(this.company_product_phase_id).pipe(takeUntilDestroyed(this.destroy_ref))
    );
    this.company_product_epics = await firstValueFrom(
      this.api.getCompanyProductEpics(this.company_product_phase_id).pipe(takeUntilDestroyed(this.destroy_ref))
    );
  }

  private initActiveTimeBudget() {
    const currentBoard = this.product_task_board();
    if (!currentBoard || currentBoard.active_product_task_board_time_budget_id == null) return;
    for (const ptbtb of currentBoard.product_task_board_time_budgets) {
      if (ptbtb.id === currentBoard.active_product_task_board_time_budget_id) {
        const updatedBoard = { ...currentBoard, active_product_task_board_time_budget: ptbtb };
        this.product_task_board.set(updatedBoard);
        break;
      }
    }
  }

  private setTitleAndDescription() {
    this.titleOriginalValue = this.task.title;
    this.descriptionOriginalValue = this.task.description;
  }

  private createProductTaskUserPickerState(): ProductTaskUserPickerState {
    return {
      control: new UntypedFormControl(''),
      filtered_users$: of([]),
      create_typed_name: '',
      auto_active_create: false,
      has_filtered: false,
    };
  }

  private initUserPickerFilters(): void {
    this.initUserPickerFilter(this.listener_user_picker, () => (this.task?.product_task_listeners ?? []).map(listener => listener.id));
    this.initUserPickerFilter(this.requester_user_picker, () => (this.task?.product_task_requesters ?? []).map(requester => requester.id));
  }

  private initUserPickerFilter(picker: ProductTaskUserPickerState, get_excluded_user_ids: () => number[]): void {
    picker.filtered_users$ = picker.control.valueChanges.pipe(
      startWith(''),
      map((value: string | User | null) => {
        if (value !== this.create_user_option_value) {
          const typed = typeof value === 'string' ? value.trim() : '';
          picker.create_typed_name = typed.length >= 3 ? typed : '';
        }

        const filtered_users = this.filterCandidateUsersForPicker(value, get_excluded_user_ids());
        picker.has_filtered = filtered_users.length > 0;
        picker.auto_active_create = picker.create_typed_name.length > 0 && !picker.has_filtered;

        return filtered_users;
      })
    );
  }

  private filterCandidateUsersForPicker(value: string | User | null, excluded_user_ids: number[]): User[] {
    const excluded_ids = new Set(excluded_user_ids);
    const raw = typeof value === 'string' && value !== this.create_user_option_value ? value : '';
    const filter_value = raw.toLowerCase().trim();

    const filtered_users = this.productTaskRequestUserList.filter(user => {
      const label = (user.full_name || `${user.name} ${user.surnames || ''}`).toLowerCase();
      const matches_search = filter_value === '' || label.includes(filter_value);

      return matches_search && !excluded_ids.has(user.id);
    });

    return this.sortUserPickerCandidates(filtered_users);
  }

  private sortUserPickerCandidates(users: User[]): User[] {
    const production_team_ids = new Set(this.production_team_users.map(user => user.id));

    return [...users].sort((a, b) => {
      const a_in_production_team = production_team_ids.has(a.id);
      const b_in_production_team = production_team_ids.has(b.id);

      if (a_in_production_team !== b_in_production_team) {
        return a_in_production_team ? -1 : 1;
      }

      return (a.full_name || `${a.name} ${a.surnames || ''}`).localeCompare(b.full_name || `${b.name} ${b.surnames || ''}`, 'es');
    });
  }

  private getUserPicker(picker_key: ProductTaskUserPickerKey): ProductTaskUserPickerState {
    return picker_key === 'listeners' ? this.listener_user_picker : this.requester_user_picker;
  }

  private getUserPickerTypedName(picker: ProductTaskUserPickerState): string {
    const value = picker.control.value;
    return typeof value === 'string' ? value.trim() : '';
  }

  private buildClientUserDialogData(name: string): AddUserDialogData {
    return {
      name,
      role: RoleSlugEnum.CLIENT,
      client_role: ClientRoleEnum.BUSINESS,
      company_id: this.product_company_id ?? undefined,
      company_name: this.product_company_name ?? undefined,
      lock_client_fields: true,
    };
  }

  private cacheProductCompany(company_product: CompanyProduct): void {
    this.product_company_id = company_product.company_id;
    this.product_company_name = company_product.company?.fact_name ?? this.product_company_name;

    if (!this.product_company_name && company_product.company_id) {
      this.api.getCompany(company_product.company_id.toString()).subscribe(company => {
        this.product_company_name = company.fact_name;
      });
    }
  }

  private ensureUserInAutocompleteList(user: User): void {
    if (this.productTaskRequestUserList.some(existing => existing.id === user.id)) {
      return;
    }

    this.productTaskRequestUserList = this.sortUserPickerCandidates([...this.productTaskRequestUserList, user]);
  }

  private initFilteredTagsListeners(): void {
    this.filtered_tags = this.tags_cntrl.valueChanges.pipe(
      startWith(null),
      debounceTime(300),
      distinctUntilChanged(),
      switchMap((tag: string | null) => {
        const term = (tag ?? '').trim();
        if (term.length < this.TAG_AUTOCOMPLETE_MIN_CHARS) {
          return of([] as string[]);
        }

        return this.api
          .getTaskTagCategories({
            search: term,
            per_page: 20,
            select: 'id|title',
          })
          .pipe(
            map((response: ProductTaskTagCategory[] | ArrayResponse<ProductTaskTagCategory>) => {
              const categories = Array.isArray(response) ? response : response.data;
              this.mergeTagCategories(categories);

              return categories
                .map((category: ProductTaskTagCategory) => category.title)
                .filter((title: string) => !this.tags.includes(title));
            }),
            catchError(() => of([] as string[]))
          );
      })
    );
  }

  private addVirtualBudgetIfNeeded(slug: string, budgets_to_display: ProductTaskBoardTimeBudgetCustom[]): void {
    if (!this.product_task_board) {
      return;
    }

    const alreadyHasBudgetWithThisSlug = budgets_to_display.some(
      (budget: ProductTaskBoardTimeBudgetCustom): boolean =>
        budget.budgetable_type === 'App\\Models\\WorkingTimeCategory' && (budget.budgetable as WorkingTimeCategory).slug === slug
    );

    const virtualBudgetConfig = this.virtualBudgets().find((vb: VirtualBudgetConfig): boolean => vb.slug === slug);

    if (alreadyHasBudgetWithThisSlug || !virtualBudgetConfig?.isEnabled) {
      return;
    }

    const setting = this.company_product_phase_task_time_autocalc_settings.find(
      (s: CompanyProductPhaseTaskTimeAutocalcSetting): boolean => s.company_product_phase_task_time_autocalc_setting_category.slug === slug
    );

    let wtc: WorkingTimeCategory | null = null;

    if (setting?.company_product_phase_task_time_autocalc_setting_category.working_time_category) {
      wtc = setting.company_product_phase_task_time_autocalc_setting_category.working_time_category;
    } else {
      firstValueFrom(this.api.getWorkingTimeCategory(slug)).then((wtc: WorkingTimeCategory): void => {
        if (!wtc || !this.product_task_board) {
          return;
        }

        const virtualBudget = this.createVirtualBudgetObject(wtc);

        const currentBoard = this.product_task_board();

        if (!currentBoard) return;

        const budgetAlreadyExists = currentBoard.product_task_board_time_budgets.some(
          (b: ProductTaskBoardTimeBudgetCustom): boolean =>
            b.budgetable_type === 'App\\Models\\WorkingTimeCategory' && (b.budgetable as WorkingTimeCategory)?.slug === slug
        );

        if (!budgetAlreadyExists) {
          const updatedBoard = {
            ...currentBoard,
            product_task_board_time_budgets: [...currentBoard.product_task_board_time_budgets, virtualBudget],
          };
          this.product_task_board.set(updatedBoard);
          this.initSpinnerData();
        }
      });
    }

    if (wtc?.id) {
      const virtualBudget = this.createVirtualBudgetObject(wtc);
      budgets_to_display.push(virtualBudget);
    }
  }

  private createVirtualBudgetObject(wtc: WorkingTimeCategory): ProductTaskBoardTimeBudgetCustom {
    return {
      id: 0,
      product_task_board_id: this.product_task_board()?.id ?? 0,
      budgetable_type: 'App\\Models\\WorkingTimeCategory',
      budgetable_id: wtc.id,
      budgetable: wtc,
      time_in_seconds: 0,
      time_registered_in_seconds_for_client: 0,
      time_registered_in_seconds_real: 0,
      assignee_id: null,
      assignee: null,
      completed_by_user_id: null,
      product_task_time_budget: undefined,
    } as any; // as any since virtual budget doesn't need all properties
  }

  private buildCompletedCategoryTooltip(timeBudget: ProductTaskBoardTimeBudgetCustom): string {
    if (timeBudget.completed_by_user_id != null) {
      return 'Esta categoría se ha completado en este tablero';
    }

    if (this.isReviewTaskBudget(timeBudget)) {
      return 'Esta categoría se ha completado en este tablero';
    }

    const other_completed_boards = this.getOtherBoardsWhereCategoryIsCompleted(timeBudget);

    if (other_completed_boards.length > 0) {
      const current_sort_time = this.getViewedBoardSortTime();
      const has_previous_board = other_completed_boards.some(
        (board: ProductTaskBoardCustom): boolean => this.getProductTaskBoardSortTime(board) < current_sort_time
      );
      const has_later_board = other_completed_boards.some(
        (board: ProductTaskBoardCustom): boolean => this.getProductTaskBoardSortTime(board) > current_sort_time
      );

      if (has_previous_board && !has_later_board) {
        return 'Esta categoría está completada en un tablero anterior';
      }

      if (has_later_board && !has_previous_board) {
        return 'Esta categoría está completada en un tablero posterior';
      }

      return 'Esta categoría está completada en otro tablero';
    }

    if (timeBudget.product_task_time_budget?.completed_by_user_id != null) {
      return 'Completada según la estimación general de la tarea';
    }

    return 'Esta categoría se ha completado en este tablero';
  }

  private isCategoryCompletedInAnyBoard(timeBudget: ProductTaskBoardTimeBudgetCustom): boolean {
    return this.getOtherBoardsWhereCategoryIsCompleted(timeBudget).length > 0;
  }

  private getOtherBoardsWhereCategoryIsCompleted(timeBudget: ProductTaskBoardTimeBudgetCustom): ProductTaskBoardCustom[] {
    return (this.task.product_task_boards ?? []).filter((board: ProductTaskBoardCustom): boolean =>
      board.product_task_board_time_budgets.some((budget: ProductTaskBoardTimeBudgetCustom): boolean => {
        return (
          budget.id !== timeBudget.id &&
          budget.budgetable_type === timeBudget.budgetable_type &&
          budget.budgetable_id === timeBudget.budgetable_id &&
          budget.completed_by_user_id != null
        );
      })
    );
  }

  private getViewedBoardSortTime(): number {
    return this.getPhaseBoardSortTime(this.currentBoard) ?? this.getProductTaskBoardSortTime(this.product_task_board());
  }

  private getProductTaskBoardSortTime(board: ProductTaskBoardCustom | undefined | null): number {
    const phase_board = board?.company_product_phase_board_col?.company_product_phase_board;

    return this.getPhaseBoardSortTime(phase_board) ?? this.toBoardSortTime(board?.created_at);
  }

  private getPhaseBoardSortTime(phaseBoard: CompanyProductPhaseBoard | undefined | null): number | null {
    if (phaseBoard == null) {
      return null;
    }

    return this.toBoardSortTime(phaseBoard.start_date ?? phaseBoard.end_date ?? phaseBoard.created_at);
  }

  private toBoardSortTime(value: Date | string | undefined | null): number {
    if (value == null) {
      return 0;
    }

    const time = new Date(value).getTime();

    return Number.isNaN(time) ? 0 : time;
  }

  private updateShowDeleteTimeBudget(time_budget: ProductTaskBoardTimeBudgetCustom): void {
    if (!this.estimation_template_data) {
      return;
    }

    const templateData = this.estimation_template_data.find(
      (data: SpinnerGroupData): boolean => data.product_task_board_time_budget?.id === time_budget.id
    );

    if (!templateData) {
      return;
    }

    templateData.show_delete_time_budget =
      time_budget.id !== 0 &&
      this.user_permissions().can_edit_board &&
      ((time_budget.budgetable as WorkingTimeCategory).is_working_time == null ||
        (time_budget.budgetable as WorkingTimeCategory).slug !== 'review-task') &&
      time_budget.assignee == null &&
      (time_budget.time_in_seconds == null || time_budget.time_in_seconds == 0) &&
      time_budget.time_registered_in_seconds_for_client == 0;
  }

  private loadTaskDeploys(): void {
    if (!this.api || !this.task?.id) {
      return;
    }
    this.api
      .getProductTaskCompanyProductDeploys(this.task.id)
      .pipe(takeUntilDestroyed(this.destroy_ref))
      .subscribe({
        next: (data: CompanyProductDeploy[]) => {
          this.taskDeploys = data;
        },
        error: error => {
          console.error('Error loading task deploys:', error);
          this.taskDeploys = [];
        },
      });
  }

  getStatusChipClass(status: string): string {
    const classes: { [key: string]: string } = {
      pending: 'mat-yellow',
      running: 'mat-accent',
      success: 'mat-success',
      failure: 'mat-warn',
      cancelled: 'mat-grey',
    };
    return classes[status] || 'mat-grey';
  }

  private updateTaskBoardTimeBudgetsAssignee(updated_product_task_board: ProductTaskBoardCustom): void {
    this.product_task_board.update((current_board: ProductTaskBoardCustom | undefined) => {
      if (!current_board) return current_board;
      return {
        ...current_board,
        active_product_task_board_time_budget: {
          ...current_board.active_product_task_board_time_budget,
          assignee_id: updated_product_task_board.active_product_task_board_time_budget?.assignee_id,
          assignee: updated_product_task_board.active_product_task_board_time_budget?.assignee,
        } as ProductTaskBoardTimeBudgetCustom,
        product_task_board_time_budgets: current_board.product_task_board_time_budgets.map((budget: ProductTaskBoardTimeBudgetCustom) => {
          const updated_budget = updated_product_task_board.product_task_board_time_budgets.find(
            (b: ProductTaskBoardTimeBudgetCustom) => b.id === budget.id
          );
          if (!updated_budget) return budget;
          return {
            ...budget,
            assignee_id: updated_budget.assignee_id,
            assignee: updated_budget.assignee,
          } as ProductTaskBoardTimeBudgetCustom;
        }),
      } as ProductTaskBoardCustom;
    });
  }

  private updateBoardCategoryEstimationTemplateData(data: ProductTaskBoardCustom): void {
    if (!this.estimation_template_data) {
      return;
    }

    this.estimation_template_data = this.estimation_template_data.map((category: SpinnerGroupData): SpinnerGroupData => {
      if (category.product_task_board_time_budget == null) {
        return { ...category };
      }

      const ptbtb = data.product_task_board_time_budgets.find(
        budget => (budget.budgetable as WorkingTimeCategory).short_name === category.title
      );
      if (!ptbtb || ptbtb.assignee_id == null) {
        return {
          ...category,
          is_assigned_to_me: false,
        };
      }

      const assignee =
        this.production_team_users.find((ucp: UserCompanyProduct) => Number(ucp.id) === Number(ptbtb.assignee_id)) ??
        ({
          ...ptbtb.assignee,
          client_role: 'developer',
        } as UserCompanyProduct);

      ptbtb.assignee = assignee;
      ptbtb.assignee_id = assignee.id;

      return {
        ...category,
        assignee,
        show_assignee: true,
        product_task_board_time_budget: ptbtb,
        is_assigned_to_me: Number(assignee.id) === Number(this.me.id),
        is_active_budget:
          data.active_product_task_board_time_budget_id != null &&
          Number(ptbtb.id) === Number(data.active_product_task_board_time_budget_id),
      };
    });
  }

  goToTask(move: TaskNavMove): void {
    if (!this.task_nav_move_abilities[move as keyof TaskNavMoveAbilities]) {
      return;
    }

    this.close(move);
  }

  private getOppositeMove(move: TaskNavMove): TaskNavMove {
    return {
      up: TaskNavMove.Down,
      down: TaskNavMove.Up,
      left: TaskNavMove.Right,
      right: TaskNavMove.Left,
    }[move];
  }

  private async playDialogLeaveAnimation(): Promise<void> {
    const move = this.goes_to_move();
    if (!move) {
      return;
    }
    const animation = this.animateDialogSurface(move, true);
    if (!animation) {
      return;
    }
    try {
      await animation.finished;
    } catch {
      return;
    }
  }

  private animateDialogSurface(move: TaskNavMove, leaving: boolean): Animation | null {
    const surface = this.getDialogSurface();
    if (!surface) {
      return null;
    }
    this.suppressMatDialogTransition();
    const offscreen = this.offscreenTransform(move);
    return surface.animate(
      leaving
        ? [
            { opacity: 1, transform: 'none' },
            { opacity: 0, transform: offscreen },
          ]
        : [
            { opacity: 0, transform: offscreen },
            { opacity: 1, transform: 'none' },
          ],
      {
        duration: this.dialog_nav_animation_ms,
        easing: 'ease-in-out',
        fill: 'forwards',
      }
    );
  }

  private getDialogSurface(): HTMLElement | null {
    return this.host_el.nativeElement.closest('.cdk-overlay-pane');
  }

  private suppressMatDialogTransition(): void {
    const inner = this.host_el.nativeElement.closest('.mat-mdc-dialog-inner-container') as HTMLElement | null;
    if (!inner) {
      return;
    }
    inner.style.setProperty('--mat-dialog-transition-duration', '0ms');
    inner.style.opacity = '1';
  }

  private offscreenTransform(move: TaskNavMove): string {
    switch (move) {
      case TaskNavMove.Up:
        return 'translateY(-100%)';
      case TaskNavMove.Down:
        return 'translateY(100%)';
      case TaskNavMove.Left:
        return 'translateX(-100%)';
      case TaskNavMove.Right:
        return 'translateX(100%)';
    }
  }
}

interface SpinnerGroupData {
  title: string;
  product_task_board_time_budget: ProductTaskBoardTimeBudgetCustom | undefined;
  product_task_time_budget: ProductTaskTimeBudgetCustom | undefined;
  should_show_completed_category_icon: boolean;
  completed_tooltip: string;
  idx: number | undefined;
  assignee: User | undefined;
  show_assignee: boolean;
  available_assignees: User[];
  can_choose_assignee: boolean;
  is_assigned_to_me: boolean;
  is_active_budget: boolean;
  can_register: boolean;
  show_delete_time_budget: boolean;
  spinners: SpinnerData[];
}

interface SpinnerData {
  tooltip: string | undefined;
  class: any;
  value: number;
  text: string;
  can_register: boolean;
}

interface AttachmentCustom extends Attachment {
  file_path_sanitized?: string;
  preview_kind: MediaPreviewKind | null;
  is_image: boolean;
  is_video: boolean;
  is_audio: boolean;
  can_preview: boolean;
  is_browser_playable: boolean;
}

interface WorkingTimeCustom extends WorkingTime {
  can_edit_or_delete: boolean;
}

interface WorkingTimeActivityEntry extends WorkingTimeCustom {
  activity_category_display: string;
}

interface ProductTaskCommentCustom extends ProductTaskComment {
  author_role: string;
}

interface ProductTaskCustom extends ProductTask {
  attachments: AttachmentCustom[];
  comments: ProductTaskCommentCustom[];
  product_task_boards: ProductTaskBoardCustom[];
  time_registered_in_seconds_for_client: number;
  time_registered_in_seconds_real: number;
  ro_working_times: WorkingTimeActivityEntry[];
  product_task_time_budgets: ProductTaskTimeBudgetCustom[];
  is_completed: boolean;
  product_task_design_links_count?: number;
}

interface ProductTaskBoardTimeBudgetCustom extends ProductTaskBoardTimeBudget {
  time_registered_in_seconds_real: number;
  time_registered_in_seconds_for_client: number;
  product_task_time_budget: ProductTaskTimeBudgetCustom | undefined;
  assignee: UserCompanyProduct | null;
}

interface ProductTaskBoardCustom extends ProductTaskBoard {
  product_task_board_time_budgets: ProductTaskBoardTimeBudgetCustom[];
  time_registered_in_seconds_real: number;
  time_registered_in_seconds_for_client: number;
  is_completed: boolean;
}

interface ProductTaskTimeBudgetCustom extends ProductTaskTimeBudget {
  time_registered_in_seconds_real: number;
  time_registered_in_seconds_for_client: number;
  completed_by_user_id: number | null;
}

interface CompanyProductPhaseTaskTimeAutocalcSettingCustom extends CompanyProductPhaseTaskTimeAutocalcSetting {
  icon: string;
}

interface UserCompanyProduct extends User {
  company_product_user_member: CompanyProductUserMember | undefined;
  client_role: 'developer' | 'business';
}

export interface ProductTaskDistributionTableColumn {
  title: string;
  time_to_do: number;
  time_done: number;
  completed: boolean;
  editable: boolean;
  budgetable_type: 'App\\Models\\WorkingTimeCategory' | 'App\\Models\\CompanyProductTeam' | undefined;
  budgetable_id: number | undefined;
  budgetable_slug: string | undefined;
}

export interface ProductTaskDistributionTableRow {
  title: string;
  company_product_phase_board_id: number | string | null;
  from: Date | undefined;
  to: Date | undefined;
  bold_title: boolean;
  categories: ProductTaskDistributionTableColumn[];
  status?: 'finished' | 'active' | 'not_started' | null;
}

export interface ProductTaskDistribution {
  general: ProductTaskDistributionTableRow;
  assigned: ProductTaskDistributionTableRow;
  boards: ProductTaskDistributionTableRow[];
}

interface VirtualBudgetConfig {
  slug: string;
  isEnabled: boolean;
}

type ProductTaskUserPickerKey = 'listeners' | 'requesters';

interface ProductTaskUserPickerState {
  control: UntypedFormControl;
  filtered_users$: Observable<User[]>;
  create_typed_name: string;
  auto_active_create: boolean;
  has_filtered: boolean;
}

export interface ProductTaskDetailDialogData {
  task_code_id: number | string;
  company_product_phase_board_id: number | string;
  company_product_id: number;
  company_product_phase_id: number;
  backdropSignal$: Subject<void>;
  company_product_phase?: CompanyProductPhase;
  company_product_epics?: CompanyProductEpic[];
  current_board?: CompanyProductPhaseBoard;
  company_product_teams?: CompanyProductTeam[] | Record<number, CompanyProductTeam>;
  company_product_phase_task_time_autocalc_settings?: CompanyProductPhaseTaskTimeAutocalcSetting[];
  user_permissions?: CompanyProductPhaseUserPermissions;
  task_nav_move_abilities?: TaskNavMoveAbilities;
  comes_from_move?: TaskNavMove;
}

export interface TaskNavMoveAbilities {
  up: boolean;
  down: boolean;
  left: boolean;
  right: boolean;
}

export enum TaskNavMove {
  Up = 'up',
  Down = 'down',
  Left = 'left',
  Right = 'right',
}

export type TaskNavMoveDisplay = {
  move: TaskNavMove;
  icon: string;
};
